const hansard = {
    "AA": "The world",
    "AA.01": "The earth",
    "AA.02": "Geographical areas/references",
    "AA.02.a": "Cardinal points",
    "AA.03": "Land, ground, land mass",
    "AA.03.a": "Continent",
    "AA.03.b": "Island",
    "AA.03.c": "Reef, sand-bank",
    "AA.03.d": "Shore, coast",
    "AA.03.e": "High/rising ground",
    "AA.03.e.01": "Volcano",
    "AA.03.e.02": "Hill",
    "AA.03.e.03": "Mountain",
    "AA.03.f": "Low ground, hollow, depression",
    "AA.03.f.01": "Hole, pit",
    "AA.03.f.02": "Valley",
    "AA.03.g": "Level land",
    "AA.03.h": "Waterlogged/wild land",
    "AA.03.i": "Fertile land, parkland",
    "AA.04": "Water",
    "AA.04.a": "Body of water",
    "AA.04.b": "Rivers, streams",
    "AA.04.b.01": "Waterfall",
    "AA.04.b.02": "Spring",
    "AA.04.b.03": "Fountain",
    "AA.04.c": "Sea/ocean",
    "AA.04.d": "Lake",
    "AA.04.e": "Pool, pond",
    "AA.04.f": "Ice",
    "AA.04.f.01": "Glacier",
    "AA.04.f.02": "Iceberg",
    "AA.04.g": "Flowing water",
    "AA.04.g.01": "Current",
    "AA.04.g.02": "Tide",
    "AA.04.g.03": "State of Sea",
    "AA.04.g.04": "Wave",
    "AA.04.g.05": "Whirlpool",
    "AA.04.g.06": "Flood/flooding",
    "AA.05": "Named regions of Earth",
    "AA.05.a": "Europe",
    "AA.05.a.01": "British Isles",
    "AA.05.a.02": "Ireland",
    "AA.05.a.03": "Scandinavia and Iceland",
    "AA.05.a.04": "Germanic region",
    "AA.05.a.05": "Low countries",
    "AA.05.a.06": "Countries of Eastern Europe",
    "AA.05.a.07": "Greece",
    "AA.05.a.08": "France/Frankish land",
    "AA.05.a.09": "Italy",
    "AA.05.a.10": "Iberian peninsula and islands",
    "AA.05.b": "Asia",
    "AA.05.b.01": "Russia/Baltic countries",
    "AA.05.b.02": "Near/Middle East/Asia Minor",
    "AA.05.b.03": "East Indies",
    "AA.05.b.04": "Far East",
    "AA.05.b.05": "Malaysia/Indonesia",
    "AA.05.c": "Australasia",
    "AA.05.c.01": "Australasia - Pacific Islands",
    "AA.05.d": "Africa",
    "AA.05.e": "The Americas",
    "AA.05.e.01": "North America",
    "AA.05.e.02": "Central and South America",
    "AA.05.e.03": "West Indies",
    "AA.05.f": "Named cities/towns",
    "AA.06": "Structure of the Earth",
    "AA.06.a": "Structural features of the Earth",
    "AA.06.a.01": "Sediment",
    "AA.06.a.02": "Volcanic Formations",
    "AA.06.a.03": "Rock formations",
    "AA.06.b": "Formation of structural features of Earth",
    "AA.06.b.01": "Earthquakes, tectonic activity",
    "AA.06.b.02": "Erosion/weathering",
    "AA.06.b.03": "Glaciation",
    "AA.07": "Geological ages/periods",
    "AA.08": "Constituent materials of Earth",
    "AA.08.a": "Rock, stone",
    "AA.08.a.01": "Sedimentary rock",
    "AA.08.a.02": "Metamorphic rock",
    "AA.08.a.03": "Igneous rock",
    "AA.08.a.04": "Ejected volcanic material",
    "AA.08.a.05": "Stone",
    "AA.08.b": "Sediment, soil, mud",
    "AA.08.b.01": "Soil",
    "AA.08.b.02": "Mud",
    "AA.08.c": "Minerals, ores",
    "AA.08.c.01": "Mineral sources",
    "AA.08.c.02": "Mineral deposits",
    "AA.08.c.03": "Ore",
    "AA.08.c.04": "Mineral structure/appearance",
    "AA.08.c.05": "Types of mineral",
    "AA.08.c.06": "Hydrocarbon minerals",
    "AA.08.c.07": "Sulphides and related minerals",
    "AA.08.c.08": "Halides",
    "AA.08.c.09": "Oxides and hydroxides",
    "AA.08.c.10": "Borates",
    "AA.08.c.11": "Silicates",
    "AA.08.c.12": "Carbonates",
    "AA.08.c.13": "Sulphates",
    "AA.08.c.14": "Phosphates",
    "AA.09": "Earth science",
    "AA.09.a": "Geography",
    "AA.09.b": "Cartography",
    "AA.09.c": "Geology",
    "AA.09.d": "Hydrography",
    "AA.09.e": "Theory of formation of Earth",
    "AA.09.f": "Environmentalism",
    "AA.10": "The Universe",
    "AA.10.a": "Space",
    "AA.10.b": "Celestial sphere, zodiacal signs",
    "AA.10.c": "Sky, heavens",
    "AA.10.d": "Heavenly body",
    "AA.10.d.01": "Heavenly body as influence on mankind",
    "AA.10.e": "Planet",
    "AA.10.e.01": "Earth and planets of Earth's solar system",
    "AA.10.e.02": "Earth's moon",
    "AA.10.e.03": "Minor planet/asteroid",
    "AA.10.f": "Stars",
    "AA.10.f.01": "Earth's sun",
    "AA.10.f.02": "Stars in relation to each other (constellation, galaxy)",
    "AA.10.g": "Comet, meteor",
    "AA.10.h": "Nebula, diffused matter",
    "AA.10.i": "Luminous appearance of Universe",
    "AA.10.j": "Cosmology, scientific study of Universe",
    "AA.10.k": "Astrology",
    "AA.10.k.01": "Horoscope",
    "AA.11": "Atmosphere, weather",
    "AA.11.a": "Fine weather",
    "AA.11.b": "Bad weather",
    "AA.11.b.01": "Thunder and lightning",
    "AA.11.c": "Cold weather",
    "AA.11.d": "Hot weather",
    "AA.11.e": "Dry weather/climate",
    "AA.11.f": "Wet weather",
    "AA.11.g": "Wind",
    "AA.11.h": "Cloud",
    "AA.11.i": "Precipitation",
    "AA.11.i.01": "Rain",
    "AA.11.i.02": "Snow",
    "AA.11.i.03": "Rainbow",
    "AA.11.j": "Study/science of weather",
    "AB": "Life",
    "AB.01": "Life, process of living",
    "AB.02": "Birth",
    "AB.03": "Age",
    "AB.04": "Sex",
    "AB.04.a": "Male sex",
    "AB.04.b": "Female sex",
    "AB.05": "Absence of life/consciousness",
    "AB.06": "Organism",
    "AB.06.a": "Micro-organism",
    "AB.06.a.01": "Bacterium",
    "AB.06.a.02": "Virus",
    "AB.06.b": "Fossil",
    "AB.07": "Biological Substance",
    "AB.07.a": "Pigment",
    "AB.07.b": "Cell",
    "AB.07.c": "Process stimulators/inhibitors",
    "AB.08": "Biological processes",
    "AB.08.a": "Movement",
    "AB.08.b": "Stimulation",
    "AB.08.c": "Action of nervous system",
    "AB.08.d": "Development/growth/degeneration",
    "AB.08.e": "Procreation/reproduction",
    "AB.08.e.01": "Infertility",
    "AB.08.e.02": "Types of reproduction",
    "AB.08.e.03": "Fecundation/impregnation",
    "AB.08.e.04": "Reproductive cycle",
    "AB.08.e.05": "Conception and gestation",
    "AB.08.e.06": "Reproductive substances/cells",
    "AB.08.e.07": "Abortion",
    "AB.08.e.08": "Contraception",
    "AB.08.f": "Genetic activity",
    "AB.08.f.01": "Genetic components",
    "AB.08.f.02": "Heredity/hereditary descent",
    "AB.08.g": "Evolution",
    "AB.09": "Ecosystem",
    "AB.10": "Physical Aspects of Organisms",
    "AB.10.a": "Physical arrangement/condition",
    "AB.10.b": "Shape",
    "AB.11": "Taxonomy",
    "AB.12": "Laboratory/scientific biology",
    "AB.13": "Study of biology",
    "AB.14": "Biological theories",
    "AB.15": "Person holding theory",
    "AB.16": "Collection/conservation of natural specimens",
    "AB.17": "The body",
    "AB.17.a": "Dead body",
    "AB.17.b": "Bodily shape/physique",
    "AB.17.b.01": "Broad shape/physique",
    "AB.17.b.02": "Slim shape/physique",
    "AB.17.c": "Bodily height",
    "AB.17.d": "Bodily constitution",
    "AB.17.d.01": "Bodily strength",
    "AB.17.d.02": "Bodily weakness",
    "AB.17.e": "Part of body",
    "AB.17.e.01": "Head",
    "AB.17.e.01.a": "Face, facial expression",
    "AB.17.e.01.b": "Eye/eyes",
    "AB.17.e.01.c": "Ear",
    "AB.17.e.01.d": "Nose",
    "AB.17.e.01.e": "Mouth",
    "AB.17.e.02": "Neck",
    "AB.17.e.03": "Trunk",
    "AB.17.e.03.a": "Back, inc. shoulders",
    "AB.17.e.03.b": "Buttock(s)",
    "AB.17.e.03.c": "Front of body",
    "AB.17.e.03.d": "Breast/breasts (of woman)",
    "AB.17.e.03.e": "Belly/abdomen",
    "AB.17.e.04": "Limb",
    "AB.17.e.04.a": "Arm",
    "AB.17.e.04.b": "Leg",
    "AB.17.e.04.c": "Hand",
    "AB.17.e.04.d": "Foot",
    "AB.17.e.04.e": "Digit - finger, toe",
    "AB.17.e.05": "Skin",
    "AB.17.e.05.a": "Textures/states of skin",
    "AB.17.e.05.b": "Complexion",
    "AB.17.e.06": "Hair",
    "AB.17.e.06.a": "Types and colours of hair",
    "AB.17.e.06.c": "Hair of head",
    "AB.17.e.06.d": "Hair on lower part of face",
    "AB.17.f": "Bodily substance, tissue",
    "AB.17.f.01": "Flesh",
    "AB.17.f.02": "Fat",
    "AB.17.g": "Bone/bones",
    "AB.17.g.01": "Skull",
    "AB.17.g.02": "Spine",
    "AB.17.g.03": "Bones of arm or leg (incl. hand and foot)",
    "AB.17.h": "Joint",
    "AB.17.i": "Muscle",
    "AB.17.j": "Sense organ",
    "AB.17.j.01": "Sight organ",
    "AB.17.j.02": "Hearing organ",
    "AB.17.j.03": "Olfactory organ",
    "AB.17.j.04": "Taste organ",
    "AB.17.k": "Speech organs",
    "AB.17.l": "Internal organs",
    "AB.17.m": "Digestive/excretive organs",
    "AB.17.m.01": "Digestive organs",
    "AB.17.m.01.a": "Mouth, teeth",
    "AB.17.m.01.b": "Throat/gullet",
    "AB.17.m.01.c": "Stomach/belly",
    "AB.17.m.01.d": "Intestines",
    "AB.17.n": "Secretory organs",
    "AB.17.n.01": "Specific glands",
    "AB.17.n.02": "Bodily secretions",
    "AB.17.o": "Organs of excretion",
    "AB.17.o.01": "Lachrymal organs",
    "AB.17.o.02": "Defecation/urination",
    "AB.17.o.03": "Excretions",
    "AB.17.p": "Sex organs",
    "AB.17.p.01": "Male sex organs",
    "AB.17.p.02": "Female sex organs",
    "AB.17.q": "Respiratory organs",
    "AB.17.q.01": "Breathing",
    "AB.17.r": "Vascular system",
    "AB.17.r.01": "Blood vessel",
    "AB.17.r.02": "Heart",
    "AB.17.r.03": "Circulation",
    "AB.17.r.04": "Blood",
    "AB.17.r.04.a": "Blood corpuscle/plate",
    "AB.17.s": "Nervous system",
    "AB.17.s.01": "Substance of nervous system, nerves",
    "AB.17.s.01.a": "Brain",
    "AB.17.t": "Study of body",
    "AB.18": "Death",
    "AB.18.a": "Dead person/the dead",
    "AB.18.b": "Manner of death",
    "AB.18.c": "Cause of death",
    "AB.18.d": "Killing",
    "AB.18.d.01": "Man-killing/homicide",
    "AB.18.d.02": "Slaughter",
    "AB.18.d.03": "Killing by specific method",
    "AB.18.d.04": "Killing of animals",
    "AB.18.d.05": "Suicide",
    "AB.18.e": "Disposal of corpse",
    "AB.18.e.01": "Means/place of burial",
    "AB.18.e.02": "Cremation",
    "AB.18.e.03": "Preparation/treatment of corpse",
    "AB.18.f": "Obsequies",
    "AB.18.f.01": "Formal/ceremonial mourning",
    "AB.18.f.02": "Monument",
    "AC.01": "Health and disease",
    "AC.01.a": "Ill-health in external/visible body parts",
    "AC.01.a.01": "Disease",
    "AC.01.a.02": "Swelling",
    "AC.01.a.03": "Eruption",
    "AC.01.a.04": "Discharge/flux",
    "AC.01.a.05": "Lameness/crippledness",
    "AC.01.a.06": "Skin disorders",
    "AC.01.a.07": "Disorders of eye/vision",
    "AC.01.a.08": "Disorders of ear/hearing",
    "AC.01.b": "Ill-health in tissue/internal organs",
    "AC.01.b.01": "Wasting disease",
    "AC.01.b.02": "Disorders of bones, muscles, etc.",
    "AC.01.b.03": "Disorders of digestive system",
    "AC.01.b.04": "Glandular disorders",
    "AC.01.b.05": "Disordered breathing",
    "AC.01.b.06": "Respiratory disorders, coughing",
    "AC.01.b.07": "Disorders of reproductive organs",
    "AC.01.b.08": "Disorders of pregnancy/birth",
    "AC.01.b.09": "Venereal disease",
    "AC.01.b.10": "Disorders of circulatory system",
    "AC.01.b.11": "Disorders of nervous system",
    "AC.01.b.12": "Convulsive/paralytic disorders",
    "AC.01.b.13": "Stupor/coma",
    "AC.01.b.14": "Fever",
    "AC.01.b.15": "Plague/pestilence",
    "AC.01.b.16": "Bacterial/viral disorders",
    "AC.01.c": "Animal disease/disorder",
    "AC.01.c.01": "Disorders of cattle/horse/sheep",
    "AC.01.c.02": "Disorders of cattle",
    "AC.01.c.03": "Disorders of horses",
    "AC.01.d": "Deformity, blemish",
    "AC.01.d.01": "Deformities of specific parts",
    "AC.01.e": "Injury",
    "AC.01.e.01": "Maiming/mutilation",
    "AC.01.f": "Pain",
    "AC.01.f.01": "Types of pain",
    "AC.01.f.02": "Pain in specific parts",
    "AC.01.g": "Mental health/sanity",
    "AC.01.g.01": "Mental illness",
    "AC.01.g.02": "Degree/type of madness",
    "AC.02": "Healing/cure",
    "AC.02.a": "Recovery",
    "AC.02.b": "Art/science of medicine",
    "AC.02.c": "Diagnosis/prognosis",
    "AC.02.c.01": "Examination",
    "AC.02.c.02": "Radiography/radiology",
    "AC.02.c.03": "Specific measuring/recording for purpose of diagnosis",
    "AC.02.d": "Medical treatment",
    "AC.02.d.01": "Treatment by medicine/drug",
    "AC.02.d.02": "Non-scientific treatments",
    "AC.02.d.03": "Surgery",
    "AC.02.d.04": "Anaesthetization/pain-killing",
    "AC.02.e": "Medicines/physic",
    "AC.02.e.01": "Medicine composed of a plant",
    "AC.02.e.02": "Medicines of specific form",
    "AC.02.e.03": "Cleansing/expelling medicines",
    "AC.02.e.04": "Preparations treating/preventing specific ailments",
    "AC.02.e.05": "Preparations for treating specific parts",
    "AC.02.e.06": "Sedatives, anti-spasmodics, etc.",
    "AC.02.f": "Medical appliances/equipment",
    "AC.02.f.01": "Surgical instruments",
    "AC.02.g": "Healer",
    "AC.02.g.01": "Physician",
    "AC.02.g.02": "Surgeon",
    "AC.02.g.03": "Alternative practitioner",
    "AC.02.g.04": "Paramedic",
    "AC.02.g.05": "Nurse",
    "AC.02.h": "Patient",
    "AC.02.i": "Places for the sick/injured",
    "AC.02.j": "Pharmacy",
    "AC.02.k": "Psychiatry",
    "AC.02.l": "Ophthalmology/optometry",
    "AC.02.m": "Dentistry",
    "AC.02.n": "Veterinary medicine and surgery",
    "AD": "People",
    "AD.01": "Science of mankind",
    "AD.02": "People collectively",
    "AD.03": "Person",
    "AD.03.a": "Man",
    "AD.03.b": "Woman",
    "AD.03.c": "Young person",
    "AD.03.c.01": "Youth/young man",
    "AD.03.c.02": "Young woman",
    "AD.03.d": "Child",
    "AD.03.d.01": "Boy",
    "AD.03.d.02": "Girl",
    "AD.03.e": "Baby/infant",
    "AD.03.f": "Adult",
    "AD.03.g": "Middle aged person",
    "AD.03.h": "Old person",
    "AD.03.h.01": "Old man",
    "AD.03.h.02": "Old woman",
    "AD.04": "Protohuman",
    "AD.05": "Race",
    "AD.05.a": "Ethnoscience",
    "AD.05.b": "Nomads",
    "AD.06": "Division by physical peculiarities",
    "AD.06.a": "White person",
    "AD.06.b": "Non-white person",
    "AD.06.c": "Black person",
    "AD.06.d": "Semite",
    "AD.06.e": "Gentile",
    "AD.06.f": "Mixed race",
    "AD.07": "Germanic people",
    "AD.08": "Celtic people, Pict",
    "AD.09": "Slav people",
    "AD.10": "Indian",
    "AD.11": "New Zealand/Australian aboriginal",
    "AD.12": "Peoples of Africa",
    "AD.13": "North American peoples",
    "AD.14": "Indian of Central/South America",
    "AD.15": "Nations",
    "AD.15.a": "National of a country",
    "AD.15.b": "Compatriots",
    "AD.15.c": "Native people",
    "AD.15.d": "Native/inhabitant of specific region",
    "AD.15.e": "Native/inhabitant of Europe",
    "AD.15.e.01": "British nation",
    "AD.15.e.02": "The Irish",
    "AD.15.e.03": "The Scandinavians",
    "AD.15.e.04": "Native/inhabitant of Germany",
    "AD.15.e.05": "The Greeks",
    "AD.15.e.06": "French nation",
    "AD.15.e.07": "The Italians",
    "AD.15.e.08": "The Spanish",
    "AD.15.e.09": "Native/inhabitant of Portugal",
    "AD.15.e.10": "Native/inhabitant of ancient/medieval Europe",
    "AD.15.f": "Native/inhabitant of Near/Middle East/Asia Minor",
    "AD.15.g": "Native/inhabitant of Asia",
    "AD.15.g.01": "Native/inhabitant of Russia/former U.S.S.R.",
    "AD.15.g.02": "The Indians",
    "AD.15.g.03": "The Chinese",
    "AD.15.h": "Native/inhabitant of Antipodes",
    "AD.15.i": "Native/inhabitant of Africa",
    "AD.15.i.01": "Native/inhabitant of N. Africa",
    "AD.15.i.02": "Native/inhabitant of E. Africa",
    "AD.15.i.03": "Native/inhabitant of Southern Africa",
    "AD.15.i.04": "Native/inhabitant of W. Africa",
    "AD.15.j": "Native/inhabitant of America",
    "AD.15.j.01": "Native/inhabitant of N. America generally",
    "AD.15.j.02": "Native/inhabitant of U.S.A.",
    "AD.15.j.03": "Native/inhabitant of Canada",
    "AD.15.j.04": "Native/inhabitant of Central America",
    "AD.15.j.05": "Native/inhabitant of W. Indies",
    "AD.15.j.06": "Native/inhabitant of S. America",
    "AE": "Animals",
    "AE.01": "Animals defined by eating habits",
    "AE.02": "Animals defined by noises",
    "AE.03": "Domestic animal",
    "AE.04": "Animals hunted",
    "AE.05": "Animal family unit",
    "AE.06": "Animals collectively",
    "AE.07": "Animal body",
    "AE.07.a": "Markings/colourings",
    "AE.07.b": "Body and limbs",
    "AE.07.c": "Rump and tail",
    "AE.07.d": "Covering/skin",
    "AE.08": "Invertebrates",
    "AE.08.a": "Protozoa",
    "AE.08.b": "Division Vermes (worms)",
    "AE.08.c": "Phylum Mollusca (moluscs)",
    "AE.08.d": "Class Gastropoda (gastropods)",
    "AE.08.e": "Class Pelecypoda/Conchifera (shellfish)",
    "AE.08.f": "Class Cephalopoda (cephalopods)",
    "AE.08.g": "Class Crustacea (crustaceans)",
    "AE.08.h": "Class Arachnida (spiders, scorpions)",
    "AE.08.i": "Class Insecta (insects)",
    "AE.08.i.01": "Parts of insects",
    "AE.08.i.02": "Eggs/young",
    "AE.08.i.03": "Order Diptera (flies)",
    "AE.08.i.04": "Order Siphonaptera (fleas)",
    "AE.08.i.05": "Order Lepidoptera (butterflies, moths)",
    "AE.08.i.06": "Rhopalocera (butterflies)",
    "AE.08.i.07": "Heterocera (moths)",
    "AE.08.i.08": "Order Coleoptera (beetles, weevils)",
    "AE.08.i.09": "Order Hymenoptera (bees, wasps)",
    "AE.09": "Vertebrates",
    "AE.10": "Fish",
    "AE.10.a": "Order Pleurotremata (sharks)",
    "AE.10.b": "Subdivision Teleostei (eels)",
    "AE.10.c": "Order Clupeiformes (herring and related fish)",
    "AE.10.d": "Order Salmoniformes (salmon, trout)",
    "AE.10.e": "Order Cyprinoidea (carp and related fish)",
    "AE.10.f": "Order Gadiformes (cod)",
    "AE.10.g": "Order Perciformes (perches)",
    "AE.11": "Class Amphibia (amphibians)",
    "AE.11.a": "Order Anura/Salienta (frogs, toads)",
    "AE.12": "Class Reptilia (reptiles)",
    "AE.12.a": "Extinct reptiles and dinosaurs",
    "AE.12.b": "Order Chelonia (turtles, tortoises)",
    "AE.12.c": "Order Crocodilia (crocodiles, alligators)",
    "AE.12.d": "Order Squamata (lizards, snakes)",
    "AE.12.d.01": "Suborder Lacertilia (lizards)",
    "AE.12.d.02": "Suborder Ophidia (snakes)",
    "AE.13": "Class Aves (birds)",
    "AE.13.a": "Wild/domestic birds",
    "AE.13.b": "Bird of prey",
    "AE.13.c": "Sound/bird defined by",
    "AE.13.d": "Egg",
    "AE.13.e": "Young bird",
    "AE.13.f": "Parts of/bird defined by",
    "AE.13.g": "Feather",
    "AE.13.h": "Order Galliformes (fowls)",
    "AE.13.h.01": "Genus Gallus (domestic fowl)",
    "AE.13.i": "Family Laridae (gulls, terns)",
    "AE.13.j": "Order Ciconiiformes (storks and related birds)",
    "AE.13.k": "Order Anseriformes (geese and related birds)",
    "AE.13.k.01": "Subfamily Merginae (ducks)",
    "AE.13.l": "Perching birds",
    "AE.13.l.01": "Order Psittaciformes (parrots and related birds)",
    "AE.13.l.02": "Order Columbiformes (doves, pigeons)",
    "AE.13.m": "Order Strigiformes (owls)",
    "AE.13.n": "Order Falconiformes (falcons and related birds)",
    "AE.13.o": "Order Passeriformes (song-birds)",
    "AE.13.o.01": "Family Corvidae (crows)",
    "AE.14": "Class Mammalia (mammals)",
    "AE.14.a": "Subclass Marsupialia (marsupials)",
    "AE.14.b": "Order Cetacea (whales, dolphins)",
    "AE.14.c": "Family Felidae (felines)",
    "AE.14.c.01": "Felis domesticus (domestic cat)",
    "AE.14.d": "Family Canidae (dogs)/member of",
    "AE.14.d.02": "Dog",
    "AE.14.e": "Family Ursidae (bears)",
    "AE.14.f": "Family Mustelidae (weasel, marten, otter, badger)",
    "AE.14.g": "Order Pinnipedia (seal, sea lion, walrus)",
    "AE.14.h": "Order Rodentia (rodents)",
    "AE.14.i": "Order Lagomorpha (rabbits, hares)",
    "AE.14.j": "Family Equidae (general equines)",
    "AE.14.j.01": "Equus caballus (horse)",
    "AE.14.j.02": "Horse defined by purpose",
    "AE.14.j.03": "Body/parts of horse",
    "AE.14.j.04": "Habits and actions of horse",
    "AE.14.j.05": "Horse defined by speed/gait",
    "AE.14.k": "Order Proboscidea (elephants)",
    "AE.14.l": "Family Suidae (pigs)",
    "AE.14.m": "Group Ruminantia (sheep, goats, cows)",
    "AE.14.m.01": "Genus Ovis (sheep)",
    "AE.14.m.02": "Subfamily Caprinae (goats)",
    "AE.14.m.03": "Subfamily Bovinae (bovines)",
    "AE.14.m.04": "Bos taurus (ox)",
    "AE.14.m.05": "Bull",
    "AE.14.m.06": "Cow",
    "AE.14.m.07": "Antelope",
    "AE.14.m.08": "Family Cervidae (deer)",
    "AE.14.n": "Order Chiroptera (bats)",
    "AE.14.o": "Order Primates",
    "AE.14.o.01": "Suborder Anthropoidea (higher primates)",
    "AE.15": "Zoology",
    "AE.15.a": "Study of specific types of animal",
    "AE.15.b": "Taxidermy",
    "AF": "Plants",
    "AF.01": "Plants collectively",
    "AF.02": "Wild/cultivated plants",
    "AF.02.a": "Food plant/vegetable",
    "AF.03": "Valued plants and weeds",
    "AF.03.a": "Edible product/fruit",
    "AF.04": "Plants defined by habitat/distribution",
    "AF.05": "Plants defined by age/cycles",
    "AF.06": "Plants defined by growth/development",
    "AF.06.a": "Plants defined by good growth",
    "AF.06.b": "Plants defined by poor growth",
    "AF.06.c": "Plants defined by habit",
    "AF.07": "Tree/woody plant",
    "AF.07.a": "Wood/assemblage of trees/shrubs",
    "AF.08": "Defined by nutrition/respiration, etc.",
    "AF.09": "Appearance of plant",
    "AF.10": "Part of plant",
    "AF.10.a": "Stem/stalk",
    "AF.10.b": "Shoot/sprout/branch",
    "AF.10.c": "Bud",
    "AF.10.d": "Root",
    "AF.10.e": "Leaf",
    "AF.10.f": "Plant substances",
    "AF.10.g": "Flower/part containing reproductive organs",
    "AF.10.h": "Reproductive product - fruit, nut",
    "AF.10.i": "Seed",
    "AF.10.j": "Spore",
    "AF.10.k": "Cell/aggregate tissue",
    "AF.10.l": "Wood, other part of tree/woody plant",
    "AF.11": "Disease of/injury to plants",
    "AF.12": "Particular plants/herbs/shrubs",
    "AF.12.a": "A grass/grasses",
    "AF.13": "Particular tree/shrub",
    "AF.13.a": "Oak and allies",
    "AF.13.b": "Conifers",
    "AF.13.c": "Non-British trees/shrubs",
    "AF.13.d": "Particular shrubs",
    "AF.14": "Cactus and allies",
    "AF.15": "Ferns",
    "AF.16": "Moss",
    "AF.17": "Fungi",
    "AF.18": "Lichen",
    "AF.19": "Algae, seaweed",
    "AF.20": "Particular food plant/product",
    "AF.20.a": "Particular types of fruit",
    "AF.20.b": "Particular fruit-tree/-plant",
    "AF.20.c": "Edible nuts/nut-trees",
    "AF.20.d": "Edible pods/seeds/leaves/flowers",
    "AF.20.e": "Particular vegetables",
    "AF.20.f": "Pulses/plants producing pulses",
    "AF.20.g": "Cereal/corn/grain",
    "AF.20.h": "Yielding condiments/used in food preparation",
    "AF.20.i": "Particular fodder plants",
    "AF.21": "Particular medicinal/food plants/parts",
    "AF.21.a": "Medicinal trees/shrubs",
    "AF.21.b": "Particular medicinal/food plants",
    "AF.22": "Yielding drug/narcotic",
    "AF.23": "Particular timber trees/shrubs",
    "AF.24": "Yielding fibre/thatching/basket material",
    "AF.25": "Particular tree/plant yielding useful gum/resin",
    "AF.26": "Plant/nut/bean yielding oil",
    "AF.27": "Plants used in dyeing",
    "AF.28": "Fragrant plants/plants used in perfumery",
    "AF.29": "Particular cultivated/ornamental plants",
    "AF.29.a": "Cultivated/ornamental trees/shrubs",
    "AF.30": "Plants perceived as weeds/harmful plants",
    "AF.30.a": "Weed",
    "AF.30.b": "Poisonous/harmful plants",
    "AG": "Food and drink",
    "AG.01": "Food",
    "AG.01.a": "Qualities of food",
    "AG.01.b": "Consistency of food",
    "AG.01.c": "Diet",
    "AG.01.d": "Animals for food",
    "AG.01.d.01": "Preserved meat",
    "AG.01.d.02": "Part/joint of animal",
    "AG.01.d.03": "Beef",
    "AG.01.d.04": "Mutton",
    "AG.01.d.05": "Pork",
    "AG.01.d.06": "Fowls",
    "AG.01.d.07": "Seafood",
    "AG.01.e": "Dairy produce",
    "AG.01.e.01": "Butter",
    "AG.01.e.02": "Cheese",
    "AG.01.f": "Fat/oil",
    "AG.01.g": "Eggs",
    "AG.01.h": "Fruit and vegetables",
    "AG.01.h.01": "Fruit/a fruit",
    "AG.01.h.01.a": "Citrus fruit",
    "AG.01.h.01.b": "Berry",
    "AG.01.h.01.c": "Apple",
    "AG.01.h.01.d": "Pear",
    "AG.01.h.01.e": "Fruit containing stone",
    "AG.01.h.01.f": "Nut",
    "AG.01.h.02": "Vegetables",
    "AG.01.h.02.a": "Root vegetable",
    "AG.01.h.02.b": "Stalk vegetables",
    "AG.01.h.02.c": "Leaf vegetables",
    "AG.01.h.02.d": "Cabbage/kale",
    "AG.01.h.02.e": "Onion/leek/garlic",
    "AG.01.h.02.f": "Fruits as vegetables",
    "AG.01.h.02.g": "Pulse",
    "AG.01.h.02.h": "Fungi",
    "AG.01.h.02.i": "Herb",
    "AG.01.i": "Corn/cereals/grain",
    "AG.01.j": "Meal",
    "AG.01.k": "Flour",
    "AG.01.l": "Additive",
    "AG.01.l.01": "Salt",
    "AG.01.l.02": "Sweetener (syrup/honey/chocolate)",
    "AG.01.l.03": "Spice",
    "AG.01.l.04": "Sauce/dressing",
    "AG.01.m": "Substances for food preparation",
    "AG.01.n": "Dishes and prepared food",
    "AG.01.n.01": "Food by way of preparation",
    "AG.01.n.02": "Soup/pottage",
    "AG.01.n.03": "Puddings",
    "AG.01.n.04": "Jelly",
    "AG.01.n.05": "Sausage",
    "AG.01.n.06": "Meat dishes",
    "AG.01.n.07": "Fish dishes",
    "AG.01.n.08": "Prepared fruit and dishes",
    "AG.01.n.09": "Prepared vegetables and dishes",
    "AG.01.n.10": "Grain dishes",
    "AG.01.n.11": "Bread",
    "AG.01.n.12": "Pancake/tortilla/oatcake",
    "AG.01.n.13": "Cake",
    "AG.01.n.14": "Biscuit",
    "AG.01.n.15": "Pastry",
    "AG.01.n.16": "Egg dishes",
    "AG.01.n.17": "Confections/sweetmeats",
    "AG.01.n.17.a": "Sweets",
    "AG.01.n.17.b": "Ices",
    "AG.01.n.18": "Preserve",
    "AG.01.o": "Animal food",
    "AG.01.p": "Amounts of food",
    "AG.01.q": "Supply of food/provisions",
    "AG.01.r": "Meal",
    "AG.01.r.01": "Meal-time",
    "AG.01.r.02": "Course",
    "AG.01.r.03": "Feast",
    "AG.01.r.04": "Picnic/packed meal",
    "AG.01.s": "Providing/receiving food",
    "AG.01.s.01": "Feeding animals",
    "AG.01.t": "Food manufacture and preparation",
    "AG.01.t.01": "Preparation of grain",
    "AG.01.t.02": "Preparation of dairy produce",
    "AG.01.t.03": "Sugar manufacture",
    "AG.01.t.04": "Salt manufacture",
    "AG.01.t.05": "Preparation for table/cooking",
    "AG.01.t.06": "Preserving/pickling",
    "AG.01.t.07": "Cooking",
    "AG.01.t.08": "Equipment for food preparation",
    "AG.01.u": "Container for food, place for storing food",
    "AG.01.v": "Serving food",
    "AG.01.w": "Setting table",
    "AG.01.x": "Consumption of food/drink",
    "AG.01.x.01": "Eating",
    "AG.01.x.01.a": "Eating place",
    "AG.01.x.02": "Appetite",
    "AG.01.x.02.a": "Hunger",
    "AG.01.x.02.b": "Excessive consumption of food/drink",
    "AG.01.x.02.c": "Fasting",
    "AG.01.y": "Drink",
    "AG.01.y.01": "Intoxicating liquor",
    "AG.01.y.01.a": "Wine",
    "AG.01.y.01.b": "Ale/beer",
    "AG.01.y.01.c": "Cider",
    "AG.01.y.01.d": "Whisky",
    "AG.01.y.01.e": "Brandy",
    "AG.01.y.01.f": "Gin",
    "AG.01.y.01.g": "Cocktail",
    "AG.01.z": "Water",
    "AG.01.aa": "Aerated/carbonated drink",
    "AG.01.ab": "Fruit juice/squash",
    "AG.01.ac": "Tea",
    "AG.01.ad": "Coffee",
    "AG.01.ae": "Manufacture of alcoholic drink",
    "AG.01.ae.01": "Wine-making",
    "AG.01.ae.02": "Malting",
    "AG.01.ae.03": "Brewing",
    "AG.01.ae.04": "Distilling",
    "AG.01.af": "Tea manufacture",
    "AG.01.ag": "Coffee manufacture",
    "AG.01.ah": "Preparation of drinks",
    "AG.01.ai": "Providing/serving drink",
    "AG.01.aj": "Containers for drink",
    "AG.01.aj.01": "Drinking vessel",
    "AG.01.ak": "Drinking",
    "AG.01.ak.01": "Drinking place",
    "AG.01.ak.02": "Thirst",
    "AG.01.ak.02.a": "Excess in drinking",
    "AG.01.ak.02.b": "Moderation in drinking",
    "AG.01.ak.02.c": "Abstention from drinking",
    "AG.02": "Production of food, farming",
    "AG.02.a": "Farmer",
    "AG.02.b": "Farm",
    "AG.02.b.01": "Farmstead",
    "AG.02.b.02": "Farmland",
    "AG.02.c": "Cultivation/tillage",
    "AG.02.c.01": "Fertilizing/manuring",
    "AG.02.c.02": "Ploughing",
    "AG.02.c.03": "Sowing",
    "AG.02.c.04": "Planting",
    "AG.02.c.05": "Cultivation of plants/crops",
    "AG.02.c.05.a": "Crop/crops",
    "AG.02.c.05.b": "Harvesting",
    "AG.02.c.05.c": "Storage/preservation of crops",
    "AG.02.d": "Tools and implements",
    "AG.02.e": "Gardening",
    "AG.02.e.01": "Garden",
    "AG.02.e.02": "Propagation of plants",
    "AG.02.e.03": "Equipment and buildings",
    "AG.02.f": "Forestry/arboriculture",
    "AG.02.g": "Animal husbandry",
    "AG.02.g.01": "Herding/pasturing/confining",
    "AG.02.g.02": "Animal enclosure/house general",
    "AG.02.g.03": "Keeping of cattle",
    "AG.02.g.04": "Dairy farming",
    "AG.02.g.05": "Sheep-farming",
    "AG.02.g.06": "Keeping of pigs",
    "AG.02.g.07": "Keeping/management of horses",
    "AG.02.g.07.a": "Shoeing of horses",
    "AG.02.g.07.b": "Horse-gear",
    "AG.02.g.08": "Keeping birds",
    "AG.02.g.08.a": "Poultry-keeping",
    "AG.02.g.09": "Fish-keeping/-farming/-breeding",
    "AG.02.g.10": "Bee-keeping",
    "AG.02.g.11": "Keeping dogs/cats",
    "AG.02.g.12": "Zoo",
    "AG.03": "Acquisition of animals for food, hunting",
    "AG.03.a": "Hunting with hounds",
    "AG.03.b": "Hunting specific animals",
    "AG.03.c": "Hunter",
    "AG.03.d": "Thing hunted/game",
    "AG.03.e": "Equipment for hunting",
    "AG.03.f": "Shooting",
    "AG.03.g": "Fowling",
    "AG.03.h": "Hawking",
    "AG.03.i": "Fishing",
    "AG.03.i.01": "Fisher",
    "AG.03.i.02": "Fishing-tackle",
    "AG.03.j": "Whaling",
    "AH": "Textiles and clothing",
    "AH.01": "Textiles",
    "AH.01.a": "Cotton",
    "AH.01.b": "Flax/hemp/jute",
    "AH.01.c": "Silk",
    "AH.01.d": "Wool",
    "AH.01.e": "Man-made textiles",
    "AH.01.f": "Treated/processed textiles",
    "AH.01.g": "Thread/yarn",
    "AH.01.h": "Textile fabric/an article of textile fabric",
    "AH.01.h.01": "Textile fabric manufactured in specific way",
    "AH.01.h.02": "Textile fabric for specific purpose",
    "AH.01.h.03": "Textile fabric made from specific material",
    "AH.01.h.03.a": "Cotton",
    "AH.01.h.03.b": "Made from flax/hemp/jute",
    "AH.01.h.03.c": "Made from silk",
    "AH.01.h.03.d": "Made from wool",
    "AH.01.h.03.e": "Made from man-made fibres",
    "AH.01.h.04": "Ornamental textiles",
    "AH.01.h.05": "Sewn/ornamented textile fabric",
    "AH.01.i": "Textile manufacture",
    "AH.01.i.01": "Treating/processing wool",
    "AH.01.i.02": "Manufacture of thread/yarn",
    "AH.01.i.03": "Manufacture textile fabric/that which consists of",
    "AH.01.i.03.a": "Treating/processing textile fabric",
    "AH.01.i.04": "Sewing/ornamenting textile fabric",
    "AH.02": "Clothing",
    "AH.02.a": "Parts of clothing",
    "AH.02.b": "Types/styles of clothing",
    "AH.02.b.01": "Underwear",
    "AH.02.b.02": "Headwear",
    "AH.02.b.03": "Neck-wear",
    "AH.02.b.04": "Clothing for body/trunk (and limbs)",
    "AH.02.b.05": "Clothing for hands",
    "AH.02.b.06": "Clothing for legs",
    "AH.02.b.07": "Footwear",
    "AH.02.b.08": "Set/suit of clothes",
    "AH.02.c": "Wearing clothing",
    "AH.02.c.01": "Nakedness/state of being unclothed",
    "AH.02.d": "Providing with/covering with clothing",
    "AH.02.d.01": "Undressing/removing clothing",
    "AH.02.e": "Tailoring/making clothes",
    "AH.02.e.01": "Making footwear",
    "AI": "Physical sensation",
    "AI.01": "Ability to be perceived by senses",
    "AI.02": "Acuteness of physical senses",
    "AI.03": "Aberrant sensory perception",
    "AI.04": "Physical insensibility",
    "AI.04.a": "Unconsciousness",
    "AI.04.b": "Dullness of sense perception",
    "AI.04.c": "Hypnotic state",
    "AI.05": "Sensuous pleasure",
    "AI.05.a": "Physical comfort",
    "AI.05.b": "Luxury/luxurious living",
    "AI.05.c": "Sensuality",
    "AI.06": "Moderation in sensuous gratification",
    "AI.07": "Asceticism",
    "AI.08": "Sleeping and waking",
    "AI.08.a": "Sleep",
    "AI.08.a.01": "Bed related to sleep/rest",
    "AI.08.a.02": "Dream",
    "AI.08.a.03": "Drowsiness",
    "AI.08.b": "State of being awake/wakefulness",
    "AI.08.c": "Weariness/exhaustion",
    "AI.08.d": "Refreshment/invigoration",
    "AI.09": "Sexual relations",
    "AI.09.a": "Sexual desire",
    "AI.09.b": "Sexual relationship",
    "AI.09.c": "Sexual partner",
    "AI.09.d": "Sexual activity",
    "AI.09.d.01": "Sexual intercourse",
    "AI.09.d.02": "Oral sex",
    "AI.09.d.03": "Anal sex",
    "AI.09.d.04": "Masturbation",
    "AI.09.e": "Types of sexual behaviour",
    "AI.09.f": "Sexual orientation",
    "AI.09.f.01": "Heterosexuality",
    "AI.09.f.02": "Homosexuality",
    "AI.09.f.03": "Bisexuality",
    "AI.09.f.04": "Transsexuality",
    "AI.09.g": "Virginity",
    "AI.09.h": "Contraception/birth control",
    "AI.10": "Use of drugs, poison",
    "AI.10.a": "Drugging a person/thing",
    "AI.10.b": "Effects of drugs",
    "AI.10.c": "Drug addiction/craving",
    "AI.10.d": "An intoxicating drug",
    "AI.10.e": "Tobacco",
    "AI.10.e.01": "Smoking",
    "AI.10.f": "Poison/a poison",
    "AI.11": "Touch/feeling",
    "AI.11.a": "Quality of being tangible",
    "AI.11.b": "Touching",
    "AI.11.b.01": "Touching with the hand",
    "AI.11.b.02": "Touching with mouth/tongue",
    "AI.11.c": "Sensation of being tickled",
    "AI.12": "Taste/flavour",
    "AI.12.a": "Insipidity",
    "AI.12.b": "Savouriness",
    "AI.12.c": "Unsavouriness",
    "AI.12.d": "Sweetness",
    "AI.12.e": "Sourness/acidity",
    "AI.13": "Smell/odour",
    "AI.13.a": "Fragrance",
    "AI.13.b": "Stench",
    "AI.14": "Sight/vision",
    "AI.14.a": "A look/glance",
    "AI.14.b": "Seeing/looking",
    "AI.14.c": "Not seeing/preventing from seeing",
    "AI.14.d": "One who sees",
    "AI.14.e": "Optical skills and techniques",
    "AI.14.f": "Optical instruments",
    "AI.14.f.01": "Instrument for distant vision",
    "AI.14.f.02": "Magnification/magnifying instruments",
    "AI.14.f.03": "Instruments for observing",
    "AI.14.f.04": "Instruments for protecting the sight",
    "AI.14.f.05": "Lens",
    "AI.14.f.06": "Mirror",
    "AI.14.g": "Types of vision",
    "AI.14.h": "Thing seen",
    "AI.14.h.01": "Place where view obtained",
    "AI.14.h.02": "Optical illusion",
    "AI.14.h.03": "Appearance/aspect",
    "AI.14.i": "Visibility",
    "AI.14.j": "Invisibility",
    "AI.15": "Hearing/noise",
    "AI.15.a": "Audibility",
    "AI.15.a.01": "Sound magnification/reproduction",
    "AI.15.b": "Inaudibility",
    "AI.15.c": "Degree/kind/quality of sound",
    "AI.15.c.01": "Loudness",
    "AI.15.c.01.a": "Roaring/bellowing",
    "AI.15.c.02": "Faintness/weakness",
    "AI.15.c.03": "Resonance/sonority",
    "AI.15.c.03.a": "Ringing sound",
    "AI.15.c.04": "Non-resonance",
    "AI.15.c.05": "Sudden/violent sound",
    "AI.15.c.05.a": "Explosive sound",
    "AI.15.c.06": "Sharp/hard sound",
    "AI.15.c.07": "Repeated sound/succession of sounds",
    "AI.15.c.08": "Continuous/protracted sound",
    "AI.15.c.08.a": "Sibilant sound",
    "AI.15.c.09": "Pleasantness of sound",
    "AI.15.c.10": "Unpleasant quality to sound",
    "AI.15.c.10.a": "Harsh/discordant quality",
    "AI.15.c.10.b": "Shrill quality",
    "AI.15.c.11": "Sound of blow/fall",
    "AI.15.c.12": "Sound of water",
    "AI.15.d": "Voice/vocal sound",
    "AI.15.d.01": "Loss/lack of voice",
    "AI.15.d.02": "Quality of voice",
    "AI.15.d.03": "Cry/exclamation",
    "AI.15.d.04": "Loud cry/shout",
    "AI.15.d.04.a": "Cry of emotion/pain",
    "AI.15.d.05": "Sounds resembling animal/bird sounds",
    "AI.15.d.06": "Other vocal sounds",
    "AI.16": "Cleanness/dirtiness",
    "AI.16.a": "Cleaning",
    "AI.16.a.01": "Washing",
    "AI.16.a.01.a": "Washing oneself/body",
    "AI.16.a.01.b": "Washing clothes and textile articles",
    "AI.16.a.01.c": "Washing of table utensils",
    "AI.16.a.01.d": "Washing agents",
    "AI.16.a.02": "Scouring/scrubbing/rubbing",
    "AI.16.a.03": "Wiping",
    "AI.16.a.04": "Polishing",
    "AI.16.a.05": "Brushing/sweeping",
    "AI.16.a.06": "Cleaning/cleanliness of the person",
    "AI.16.a.07": "Cleaning house",
    "AI.16.b": "Freedom from impurities",
    "AI.16.b.01": "Removal of impurities",
    "AI.16.c": "Pest control",
    "AI.16.d": "Clearing of refuse matter",
    "AI.16.e": "Sanitation",
    "AI.16.e.01": "Privy/latrine",
    "AI.16.e.02": "Sewers and sewage",
    "AI.16.f": "Dirtiness",
    "AI.16.f.01": "Dirty person",
    "AI.16.f.02": "Dirty place",
    "AI.16.f.03": "Dirt",
    "AI.16.f.03.a": "Soiled condition",
    "AI.16.f.03.b": "Dirtiness/soiling with specific kinds of dirt",
    "AI.16.f.04": "Pollution/defilement",
    "AI.16.f.04.a": "Environmental pollution",
    "AI.16.f.05": "Corruption/putridness",
    "AI.16.f.06": "Infestation by noxious creatures",
    "AI.16.g": "Refuse/rubbish",
    "AJ": "Matter",
    "AJ.01": "Alchemy",
    "AJ.02": "Chemistry",
    "AJ.02.a": "Chemistry as a science",
    "AJ.02.a.01": "Branches of chemistry",
    "AJ.02.b": "Equipment/apparatus",
    "AJ.02.c": "Chemical tests",
    "AJ.02.d": "Chemical assay/analytical chemistry",
    "AJ.02.e": "Valency",
    "AJ.02.f": "Chemical bonding",
    "AJ.02.g": "Chemical structure/stereochemistry",
    "AJ.02.h": "Isomerism",
    "AJ.02.i": "Chemical reactions/processes",
    "AJ.02.j": "Chemical properties",
    "AJ.02.k": "Ions/ionization/electrolysis",
    "AJ.02.l": "Elements and compounds",
    "AJ.02.l.01": "Hydrogen",
    "AJ.02.l.02": "Metals",
    "AJ.02.m": "Organic chemistry",
    "AJ.02.m.01": "Hydrocarbons",
    "AJ.02.m.02": "Alcohols",
    "AJ.02.m.03": "Carbohydrates",
    "AJ.02.m.03.a": "Sugars",
    "AJ.02.m.04": "Organic acids",
    "AJ.02.m.05": "Organic salts",
    "AJ.02.m.06": "Alkaloids",
    "AJ.02.m.07": "Organic compounds",
    "AJ.02.m.08": "Chemical processes/reactions",
    "AJ.02.n": "Polymer chemistry",
    "AJ.02.n.01": "Resins and plastics",
    "AJ.02.o": "Crystallography (general)",
    "AJ.02.p": "Physical chemistry",
    "AJ.02.q": "Chemical substances",
    "AJ.02.q.01": "Acids",
    "AJ.02.q.02": "Bases",
    "AJ.02.q.03": "Salts",
    "AJ.02.r": "Atomic chemistry",
    "AJ.03": "Properties of materials",
    "AJ.03.a": "Weight/relative heaviness",
    "AJ.03.b": "Lightness",
    "AJ.03.c": "Temperature",
    "AJ.03.c.01": "Measurement of temperature",
    "AJ.03.c.02": "Heat",
    "AJ.03.c.02.a": "Heating/making hot/warm",
    "AJ.03.c.02.b": "Action of boiling",
    "AJ.03.c.02.c": "Burning, fire, flame, ash",
    "AJ.03.c.03": "Coldness",
    "AJ.03.c.03.a": "Cooling agent/appliance",
    "AJ.03.c.03.b": "Quality of being incombustible",
    "AJ.03.c.03.c": "Extinguishing fire",
    "AJ.04": "Constitution of matter",
    "AJ.04.a": "Density/solidity",
    "AJ.04.a.01": "State of being thick enough to retain form",
    "AJ.04.a.02": "Viscosity",
    "AJ.04.b": "Lack of density",
    "AJ.04.c": "Granular texture",
    "AJ.04.d": "Other specific kinds of texture",
    "AJ.04.e": "Strength",
    "AJ.04.f": "Weakness",
    "AJ.04.g": "Hardness",
    "AJ.04.h": "Softness",
    "AJ.04.h.01": "Types of softness",
    "AJ.04.h.02": "Pliableness",
    "AJ.04.i": "Unctuousness",
    "AJ.05": "Liquid",
    "AJ.05.a": "Making liquid/melting",
    "AJ.05.b": "Water",
    "AJ.05.c": "Moisture/humidity",
    "AJ.05.d": "Condition of being/making wet",
    "AJ.05.d.01": "Condition of being slightly wet",
    "AJ.05.d.02": "Condition of being/making very wet",
    "AJ.05.d.03": "Condition of being submerged/action of submerging",
    "AJ.05.e": "Action/process of absorbing",
    "AJ.05.f": "Action/process of extracting",
    "AJ.05.g": "Liquid which has been emitted",
    "AJ.05.h": "Action/process of flowing",
    "AJ.05.h.01": "Action/fact of pouring/being poured",
    "AJ.05.h.02": "Action/process of squirting/issuing in a jet",
    "AJ.05.h.03": "Action/process of spraying",
    "AJ.05.h.04": "Action/process of splashing",
    "AJ.05.h.05": "Action/process of sprinkling",
    "AJ.05.h.06": "Action/process of dripping/falling in drops",
    "AJ.05.i": "Fact of being still/not flowing",
    "AJ.05.j": "Action/process of floating",
    "AJ.05.k": "Dryness",
    "AJ.06": "Gas",
    "AJ.06.a": "Becoming/making into gas",
    "AJ.06.b": "Gas/air in liquid/effervescence",
    "AJ.06.c": "Air",
    "AJ.06.c.01": "Moving air",
    "AJ.06.c.02": "Fresh air",
    "AJ.07": "Physics",
    "AJ.07.a": "Mechanics",
    "AJ.07.a.01": "Force",
    "AJ.07.a.01.a": "Stress/force exerted and tending to deform",
    "AJ.07.a.01.b": "Gravity",
    "AJ.07.a.02": "Fluid mechanics",
    "AJ.07.a.03": "Dynamics",
    "AJ.07.a.03.a": "Fluid dynamics",
    "AJ.07.a.03.b": "Statics",
    "AJ.07.a.03.c": "Thermodynamics",
    "AJ.07.a.04": "Kinematics",
    "AJ.07.a.05": "Types of motion",
    "AJ.07.b": "Energy/power of doing work",
    "AJ.07.c": "Electromagnetic radiation",
    "AJ.07.c.01": "Radio wave",
    "AJ.07.c.01.a": "Microwave",
    "AJ.07.c.02": "Heat",
    "AJ.07.c.03": "Light",
    "AJ.07.c.03.a": "Emission of light, radiation",
    "AJ.07.c.03.b": "Refraction",
    "AJ.07.c.03.c": "Diffraction",
    "AJ.07.c.03.d": "Reflection",
    "AJ.07.c.03.e": "Intensity of light, luminosity",
    "AJ.07.c.03.f": "Laser",
    "AJ.07.c.03.g": "Chromatism",
    "AJ.07.c.04": "Science of sound",
    "AJ.07.c.04.a": "Sound-waves",
    "AJ.07.c.04.b": "Vibration",
    "AJ.07.c.05": "Electricity",
    "AJ.07.c.05.a": "Galvanism, voltaism",
    "AJ.07.c.05.b": "Electric charge, electricity",
    "AJ.07.c.05.c": "Discharge of electricity",
    "AJ.07.c.05.d": "Electrically induced magnetism",
    "AJ.07.c.05.e": "Electric current",
    "AJ.07.c.05.f": "Resistance",
    "AJ.07.c.05.g": "Transmission of electricity, conduction",
    "AJ.07.c.05.h": "Voltage",
    "AJ.07.c.05.i": "Electrical appliances/devices",
    "AJ.07.c.05.j": "Circuit",
    "AJ.07.c.05.k": "Electrical engineering, electrical components",
    "AJ.07.c.05.l": "Electrical power; incl. generation and distribution",
    "AJ.07.c.06": "Magnetism",
    "AJ.07.c.06.a": "Magnetic devices/materials",
    "AJ.07.c.07": "Electronics",
    "AJ.07.c.07.a": "Electronic phenomena",
    "AJ.07.c.07.b": "Electronic devices/components",
    "AJ.07.d": "Solid state physics",
    "AJ.07.e": "Atomic physics",
    "AJ.07.e.01": "Ion",
    "AJ.07.e.02": "Decomposition of light, spectrum",
    "AJ.07.e.03": "Particle physics",
    "AJ.07.e.03.a": "Particle accelerator",
    "AJ.07.e.03.b": "Particle avoiding strong interaction (electron, muon, neutrino)",
    "AJ.07.e.03.c": "Hadron",
    "AJ.07.e.03.d": "Quark",
    "AJ.07.e.03.e": "Photon particle",
    "AJ.07.f": "Atomic nucleus",
    "AJ.07.f.01": "Radioactivity",
    "AJ.07.f.01.a": "X-rays",
    "AJ.07.f.02": "Measurement of ionizing radiation",
    "AJ.07.f.03": "Radioactive isotope",
    "AJ.07.f.04": "Nuclear fission",
    "AJ.07.f.04.a": "Nuclear reactor",
    "AJ.07.f.04.b": "Nuclear fuel",
    "AJ.07.f.04.c": "Nuclear fusion",
    "AJ.07.f.04.d": "Nuclear explosion",
    "AJ.07.g": "Quantum theory",
    "AJ.07.g.01": "Quantum mechanics",
    "AJ.07.h": "Relativity",
    "AJ.07.h.01": "Space-time",
    "AJ.08": "Light",
    "AJ.08.a": "Intensity of light",
    "AJ.08.b": "Light emitted in particular manner",
    "AJ.08.c": "Light emitted under particular conditions",
    "AJ.08.d": "Illumination",
    "AJ.08.e": "Reflection",
    "AJ.08.f": "Naturally occurring light",
    "AJ.08.g": "Artificial light",
    "AJ.08.g.01": "Artificial light defined by light-source",
    "AJ.08.g.01.a": "Electric light",
    "AJ.08.g.02": "Torch",
    "AJ.08.g.03": "Candle",
    "AJ.08.h": "Firework",
    "AJ.08.i": "Transparency/translucence",
    "AJ.08.i.01": "Opacity",
    "AJ.08.j": "Darkness/absence of light",
    "AJ.08.j.01": "Dimness/absence of brightness",
    "AJ.08.j.02": "Darkness/gloom",
    "AJ.08.j.03": "Intercepting/cutting off of light",
    "AJ.09": "Colour",
    "AJ.09.a": "Quality of colour",
    "AJ.09.b": "State/mode of having colour",
    "AJ.09.b.01": "Absence of colour",
    "AJ.09.c": "Colouring",
    "AJ.09.c.01": "Painting",
    "AJ.09.c.02": "Dyeing",
    "AJ.09.c.03": "Colouring matter",
    "AJ.09.d": "Science of colour",
    "AJ.09.e": "Named colours",
    "AJ.09.e.01": "White/whiteness",
    "AJ.09.e.01.a": "Whitening",
    "AJ.09.e.02": "Black/blackness",
    "AJ.09.e.02.a": "Making/becoming black",
    "AJ.09.e.03": "Red/redness",
    "AJ.09.e.03.a": "Making/becoming red",
    "AJ.09.e.03.b": "Red colouring matter",
    "AJ.09.e.04": "Green/greenness",
    "AJ.09.e.05": "Yellow/yellowness",
    "AJ.09.e.05.a": "Making yellow",
    "AJ.09.e.05.b": "Colouring matter",
    "AJ.09.e.06": "Blue/blueness",
    "AJ.09.e.06.a": "Blue colouring matter",
    "AJ.09.e.07": "Brown/brownness",
    "AJ.09.e.08": "Grey/greyness",
    "AJ.09.e.09": "Purple/purpleness",
    "AJ.09.e.10": "Orange",
    "AJ.09.f": "Variegation",
    "AJ.09.f.01": "Iridescence",
    "AJ.09.f.02": "Stripiness",
    "AJ.09.f.03": "Spot of colour",
    "AJ.10": "Condition of matter",
    "AJ.10.a": "State of being undecayed",
    "AJ.10.b": "Bad condition of matter",
    "AK": "Existence and causation",
    "AK.01": "Existence",
    "AK.01.a": "Non-existence",
    "AK.01.b": "Reality/real existence/actuality",
    "AK.01.c": "Substantiality/concreteness",
    "AK.01.c.01": "Unsubstantiality/abstractness",
    "AK.01.d": "Materiality",
    "AK.01.d.01": "Immateriality",
    "AK.01.e": "Intrinsicality/inherence",
    "AK.01.e.01": "Essence/intrinsic nature",
    "AK.01.e.02": "Character/nature",
    "AK.01.e.03": "Introduction/bringing in",
    "AK.01.f": "Extrinsicality/externality",
    "AK.01.f.01": "Objectivity",
    "AK.01.g": "State/condition",
    "AK.01.g.01": "Circumstance/circumstances",
    "AK.01.g.02": "Tendency",
    "AK.01.g.03": "Infiniteness",
    "AK.02": "Creation",
    "AK.02.a": "Productiveness",
    "AK.02.a.01": "Unproductiveness",
    "AK.02.b": "Destruction",
    "AK.02.b.01": "Breaking/cracking",
    "AK.02.b.02": "Cutting",
    "AK.02.b.03": "Tearing/tearing apart",
    "AK.02.b.04": "Biting",
    "AK.02.b.05": "Damage",
    "AK.02.b.06": "Rubbing/friction",
    "AK.02.b.07": "Pressing/pressure/squeezing",
    "AK.02.b.08": "Grinding/pounding",
    "AK.03": "Cause",
    "AK.03.a": "Cause/reason",
    "AK.03.b": "Source/origin",
    "AK.03.c": "Basis/foundation",
    "AK.03.d": "Initiating/causing to begin",
    "AK.03.e": "Attribution/assignment of cause",
    "AK.03.f": "Effect/result/consequence",
    "AK.03.g": "Chance/causelessness",
    "AK.04": "Present events",
    "AK.04.a": "Future events",
    "AL": "Space",
    "AL.01": "Distance",
    "AL.01.a": "Distance/farness",
    "AL.01.b": "Nearness",
    "AL.02": "Extension in space",
    "AL.02.a": "Spreading/diffusion",
    "AL.02.b": "Expansion/enlargement",
    "AL.02.c": "Reduction in size/extent",
    "AL.02.d": "Measurable spatial extent",
    "AL.02.d.01": "Largeness",
    "AL.02.d.02": "Smallness",
    "AL.02.d.03": "Longitudinal extent",
    "AL.02.d.04": "Breadth/width",
    "AL.02.d.05": "Thickness",
    "AL.02.d.06": "Vertical extent",
    "AL.03": "Shape",
    "AL.03.a": "Lack of shape",
    "AL.03.b": "Mis-shapenness",
    "AL.03.c": "Symmetry/regularity",
    "AL.03.d": "Straightness",
    "AL.03.e": "Angularity",
    "AL.03.e.01": "Specific angular shape",
    "AL.03.f": "Curvature",
    "AL.03.f.01": "Types of curvature",
    "AL.03.f.02": "Roundness",
    "AL.03.f.03": "Coil",
    "AL.03.f.04": "Curved three-dimensional shape/body, cylinder",
    "AL.03.f.05": "Curved surface",
    "AL.03.g": "Flatness/levelness",
    "AL.03.g.01": "Smoothness",
    "AL.03.h": "Unevenness",
    "AL.03.h.01": "Projection/prominence, rough surface",
    "AL.03.h.02": "Condition/fact of receding",
    "AL.03.h.03": "Hollowness",
    "AL.03.i": "Fact/condition of tapering",
    "AL.03.j": "Sharpness of edge/point",
    "AL.03.k": "Bluntness",
    "AL.04": "Place",
    "AL.04.a": "Position/situation",
    "AL.04.b": "Here/there, etc.",
    "AL.04.c": "Presence",
    "AL.04.c.01": "Fact of taking up space",
    "AL.04.d": "Absence",
    "AL.04.d.01": "Fact of being unoccupied",
    "AL.04.e": "Placing/fact of being placed in (a) position",
    "AL.04.e.01": "Insertion/putting in",
    "AL.04.f": "Removal/displacement",
    "AL.04.f.01": "Extraction",
    "AL.05": "Relative position",
    "AL.05.a": "Condition of being internal",
    "AL.05.b": "Central condition/position",
    "AL.05.c": "Condition of being external",
    "AL.05.c.01": "Surface",
    "AL.05.c.02": "Edge/border/margin, boundary",
    "AL.05.c.03": "Surrounding",
    "AL.05.c.04": "Enclosing/enclosure",
    "AL.05.c.05": "Covering, wrapping, coating with a layer",
    "AL.05.c.06": "Uncovering",
    "AL.05.d": "Condition of being open/not closed",
    "AL.05.d.01": "An opening/aperture",
    "AL.05.d.02": "Making holes/becoming holed",
    "AL.05.e": "Closed/shut condition",
    "AL.05.e.01": "A barrier",
    "AL.05.f": "Condition/fact of being interjacent",
    "AL.05.g": "High position",
    "AL.05.h": "Low position",
    "AL.05.i": "Support",
    "AL.05.i.01": "Hanging/suspension",
    "AL.05.i.02": "Absence of support",
    "AL.05.j": "Front",
    "AL.05.k": "Position at the back",
    "AL.05.l": "Quality of having sides/being a side",
    "AL.05.m": "End/extremity",
    "AL.05.n": "Vertical position",
    "AL.05.o": "Horizontal position/condition",
    "AL.05.p": "Inclination",
    "AL.05.q": "Fact/condition of being transverse",
    "AL.05.q.01": "Intersection",
    "AL.05.r": "Opposite position",
    "AL.05.s": "Inversion",
    "AL.05.t": "Folding/folded condition",
    "AL.05.u": "Intertwining/interweaving",
    "AL.05.v": "Arrangement/fact of being arranged",
    "AL.05.v.01": "Absence of arrangement",
    "AL.05.v.02": "State of being gathered together, assembled",
    "AL.05.v.03": "State of being scattered/dispersed",
    "AL.05.w": "Posture",
    "AL.05.w.01": "Action of standing up/rising",
    "AL.05.w.02": "Action/fact of sitting",
    "AL.05.w.03": "Action/act of kneeling",
    "AL.05.w.04": "Action/fact of lying down/reclining",
    "AL.05.w.05": "Action/fact of bending",
    "AL.05.w.06": "Action/fact of stretching body",
    "AL.06": "Direction",
    "AL.06.a": "Specific directions",
    "AM": "Time",
    "AM.01": "Spending time",
    "AM.02": "Duration",
    "AM.02.a": "Eternity/infinite duration",
    "AM.02.b": "Shortness/brevity in time",
    "AM.02.b.01": "Swift movement of time",
    "AM.03": "Particular time",
    "AM.03.a": "An anniversary",
    "AM.04": "Period",
    "AM.04.a": "Year",
    "AM.04.a.01": "Season",
    "AM.04.b": "A month/calendar month",
    "AM.04.c": "A week",
    "AM.04.d": "A day/twenty-four hours",
    "AM.04.e": "Cycle of time",
    "AM.05": "Day and night",
    "AM.05.a": "Day/day-time",
    "AM.05.b": "Night",
    "AM.06": "Instruments for measuring time",
    "AM.06.a": "Clock",
    "AM.06.b": "Watch",
    "AM.07": "Reckoning of time",
    "AM.07.a": "Chronology",
    "AM.07.b": "Calendar",
    "AM.08": "Relative time",
    "AM.08.a": "Immediacy",
    "AM.08.b": "The present (time)",
    "AM.08.c": "The past",
    "AM.08.c.01": "Historical period",
    "AM.08.c.02": "Antecedence/being earlier",
    "AM.08.c.03": "Oldness/ancientness",
    "AM.08.c.04": "History/knowledge about the past",
    "AM.08.d": "The future/time to come",
    "AM.08.d.01": "Succession/following in time",
    "AM.08.d.02": "Newness/novelty, recency",
    "AM.09": "Suitable time/opportunity",
    "AM.09.a": "Untimeliness",
    "AM.09.a.01": "Delay/postponement",
    "AM.10": "Frequency",
    "AM.10.b": "Infrequency",
    "AM.11": "Change",
    "AM.11.a": "Changeableness",
    "AM.11.b": "Change to something else, transformation",
    "AM.11.c": "Alternation",
    "AM.11.d": "Exchange",
    "AM.11.d.01": "Substitution",
    "AM.11.e": "Absence of change, changelessness",
    "AM.11.e.01": "Lasting quality, permanence",
    "AN": "Movement",
    "AN.01": "Bodily movement",
    "AN.02": "Motion in specific manner",
    "AN.02.a": "Sudden movement",
    "AN.02.b": "Alternating/reciprocating motion",
    "AN.02.b.01": "Oscillation, vibration",
    "AN.02.c": "Irregular movement/agitation",
    "AN.02.c.01": "Unsteady movement",
    "AN.02.d": "Writhing/twisting movement",
    "AN.02.e": "Revolution/rotation",
    "AN.03": "Progressive motion",
    "AN.03.a": "Walking",
    "AN.03.b": "Moving along with hands and feet/with body prone",
    "AN.03.c": "Moving with current of air/water",
    "AN.03.c.01": "Movement in/on water",
    "AN.03.c.02": "Motion in the air",
    "AN.03.d": "Order of movement",
    "AN.03.d.01": "Going first/in front",
    "AN.03.d.02": "Following behind",
    "AN.04": "Rate of motion",
    "AN.04.a": "Swiftness",
    "AN.04.a.01": "Going swiftly on foot",
    "AN.04.a.02": "Swift movement in specific manner",
    "AN.04.b": "Slowness",
    "AN.05": "Motion in a certain direction",
    "AN.05.a": "A straight course",
    "AN.05.b": "Change of direction of movement",
    "AN.05.c": "Movement in circle/curve",
    "AN.05.d": "Forward movement",
    "AN.05.e": "Backward movement",
    "AN.05.f": "Sideways movement/a sideways movement",
    "AN.05.g": "Upward movement",
    "AN.05.g.01": "Raising",
    "AN.05.g.02": "Leaping/springing/jumping",
    "AN.05.h": "Downward motion",
    "AN.05.h.01": "Falling",
    "AN.05.h.02": "Causing to come/go down",
    "AN.05.i": "Movement over/across/through/past",
    "AN.05.j": "Going/coming in",
    "AN.05.k": "Going/coming out",
    "AN.05.k.01": "Letting/sending out",
    "AN.05.l": "Movement towards a thing/person/position",
    "AN.05.l.01": "Meeting/encounter",
    "AN.05.l.02": "Reaching a point/place",
    "AN.05.m": "Going away",
    "AN.05.m.01": "Causing to go away",
    "AN.06": "Transference",
    "AN.07": "Impelling/driving",
    "AN.07.a": "Projecting through space/throwing",
    "AN.07.b": "Pushing and pulling",
    "AN.08": "Impact",
    "AN.08.a": "Striking",
    "AN.08.a.01": "Beating/repeated striking",
    "AN.08.a.02": "Striking with specific degree of force",
    "AN.08.a.03": "Striking in specific manner",
    "AN.08.a.04": "Striking with specific thing",
    "AN.09": "Absence of movement",
    "AN.09.a": "Hold/holding",
    "AN.10": "Restlessness",
    "AO": "Action/operation",
    "AO.01": "Operation upon something",
    "AO.02": "Doing",
    "AO.02.a": "Practice/exercise",
    "AO.02.b": "Activity/occupation",
    "AO.02.b.01": "Acting in another's business/intervention",
    "AO.03": "Undertaking",
    "AO.03.a": "Preparation",
    "AO.03.a.01": "Unpreparedness",
    "AO.04": "Beginning action/activity",
    "AO.05": "Repeating",
    "AO.06": "Continuing",
    "AO.06.a": "Progress/advance/further continuance",
    "AO.07": "Carrying out",
    "AO.08": "Completing",
    "AO.08.a": "Non-completion",
    "AO.09": "Ceasing",
    "AO.09.a": "Temporary cessation of activity/operation",
    "AO.10": "Inaction",
    "AO.10.a": "Quietness/tranquillity",
    "AO.10.b": "Not doing",
    "AO.10.b.01": "Abstaining/refraining from action",
    "AO.10.c": "Idleness/lack of occupation/activity",
    "AO.10.d": "Disinclination to act/listlessness",
    "AO.10.d.01": "Sloth/laziness",
    "AO.11": "Endeavour",
    "AO.11.a": "Trial/experiment",
    "AO.11.a.01": "Trial/test/testing",
    "AO.11.b": "Searching/seeking",
    "AO.11.b.01": "Finding/discovery",
    "AO.12": "Difficulty",
    "AO.12.a": "Types of difficulty",
    "AO.12.b": "Practical impossibility",
    "AO.12.c": "Hindrance",
    "AO.12.c.01": "Types/manners of hindrance",
    "AO.12.c.02": "Hindering completely/preventing",
    "AO.12.d": "Opposition",
    "AO.12.d.01": "Absence of resistance",
    "AO.13": "Easiness",
    "AO.13.a": "Support",
    "AO.13.a.01": "Support/encouragement",
    "AO.13.b": "Intercession/influence on someone's behalf",
    "AO.14": "Amending",
    "AO.14.a": "Restoration",
    "AO.14.a.01": "Restoration of a person",
    "AO.15": "Advantage",
    "AO.15.a": "Usefulness",
    "AO.15.a.01": "Use (made of things)",
    "AO.15.b": "Efficacy",
    "AO.15.c": "Convenience",
    "AO.15.d": "Expediency",
    "AO.15.e": "An opportunity",
    "AO.16": "Safety",
    "AO.16.a": "Protection/defence",
    "AO.16.a.01": "Preservation from injury/destruction",
    "AO.16.a.02": "Refuge/shelter",
    "AO.16.a.03": "Vigilance",
    "AO.16.a.04": "Watching/keeping guard/watchful guard",
    "AO.16.a.05": "Care/protection/charge",
    "AO.16.b": "Rescue/deliverance",
    "AO.16.c": "Escape",
    "AO.17": "Prosperity",
    "AO.17.a": "Advancement/progress",
    "AO.17.a.01": "Outdoing/surpassing",
    "AO.17.b": "Success",
    "AO.17.b.01": "Mastery/superiority",
    "AO.17.b.02": "Token of victory/supreme excellence",
    "AO.18": "Harm/detriment",
    "AO.18.a": "Hostile action/attack",
    "AO.18.b": "Disadvantage",
    "AO.18.b.01": "Uselessness",
    "AO.18.b.02": "Misuse",
    "AO.18.b.03": "Non-use",
    "AO.18.c": "Danger",
    "AO.18.c.01": "Warning of imminent danger/evil",
    "AO.18.c.02": "Threat/threatening",
    "AO.19": "Adversity",
    "AO.19.a": "Calamity/misfortune",
    "AO.20": "Failure/lack of success",
    "AO.20.a": "Defeat/overthrow",
    "AO.21": "Manner of action",
    "AO.21.a": "Vigour/energy",
    "AO.21.b": "Effort/exertion",
    "AO.21.c": "Violent action/operation",
    "AO.21.c.01": "Severity",
    "AO.21.d": "Lack of violence/severity/intensity",
    "AO.21.e": "Speed of action/operation",
    "AO.21.f": "Slowness of action/operation",
    "AO.21.g": "Care/carefulness/attention",
    "AO.21.g.01": "Caution",
    "AO.21.h": "Carelessness",
    "AO.21.h.01": "Incautiousness",
    "AO.22": "Behaviour",
    "AO.22.a": "A standard of conduct",
    "AO.22.b": "Customary/habitual mode of behaviour",
    "AO.22.b.01": "Unaccustomedness",
    "AO.22.c": "Good behaviour",
    "AO.22.c.01": "Courtesy",
    "AO.22.c.02": "Kindness, gentleness, mildness",
    "AO.22.c.03": "Restrained/moderate behaviour",
    "AO.22.d": "Bad behaviour",
    "AO.22.d.01": "Discourtesy",
    "AO.22.d.02": "Unkindness",
    "AO.22.d.03": "Harshness/severity",
    "AO.22.d.04": "Fierceness",
    "AO.22.d.05": "Ill-treatment",
    "AO.22.d.06": "Violent behaviour",
    "AO.22.d.07": "Lack of moderation/restraint",
    "AO.22.e": "Affected behaviour/affectation",
    "AO.22.f": "Unaffectedness/naturalness",
    "AO.22.g": "Reciprocal treatment/return of an action",
    "AO.22.g.01": "Reward/a reward",
    "AO.22.g.02": "Revenge",
    "AO.23": "Ability",
    "AO.23.a": "Skill/skilfulness",
    "AO.23.a.01": "Cunning",
    "AO.23.b": "Inability",
    "AO.23.b.01": "Unskilfulness",
    "AP": "Relative properties",
    "AP.01": "Relation/relationship",
    "AP.01.a": "Non-relation",
    "AP.01.b": "Relevance/pertinence",
    "AP.01.c": "Correlation",
    "AP.01.d": "Identity",
    "AP.01.e": "Contrariety/contrast",
    "AP.01.f": "Difference",
    "AP.01.g": "Uniformity",
    "AP.01.h": "Variety",
    "AP.01.i": "Similarity",
    "AP.01.j": "Imitation",
    "AP.01.j.01": "Non-imitation/originality",
    "AP.01.k": "Equality/equivalence",
    "AP.01.k.01": "Inequality",
    "AP.01.k.02": "Condition of being mean/average",
    "AP.01.l": "Accompaniment",
    "AP.02": "Kind/sort",
    "AP.02.a": "Generality",
    "AP.02.a.01": "Condition/state of being inclusive",
    "AP.02.b": "Individual character/quality",
    "AP.02.b.01": "An individual case/instance",
    "AP.02.b.02": "Quality of being special/restricted in application",
    "AP.02.b.03": "The quality of being specific",
    "AP.02.b.04": "Quality of being special/extraordinary",
    "AP.02.b.05": "Quality of being exclusive",
    "AP.03": "Order",
    "AP.03.a": "Agreement/harmony/congruity",
    "AP.03.a.01": "Suitability/appropriateness",
    "AP.03.a.02": "Conformity to/with a pattern etc.",
    "AP.03.a.03": "Adaptation/adjustment",
    "AP.03.b": "Disorder",
    "AP.03.b.01": "Confusion/disorder",
    "AP.03.b.01.a": "Entanglement/entangled state, complication/complexity",
    "AP.03.b.01.b": "Untidiness",
    "AP.03.b.01.c": "Commotion/disturbance/disorder",
    "AP.03.b.02": "Irregularity",
    "AP.03.b.02.a": "Unconformity, abnormality",
    "AP.03.b.03": "Disharmony/incongruity",
    "AP.03.b.03.a": "Unsuitability/inappropriateness",
    "AP.03.c": "Order/sequence/succession",
    "AP.03.c.01": "Preceding/following in order",
    "AP.03.c.02": "Beginning",
    "AP.03.c.03": "End/conclusion",
    "AP.03.c.04": "Continuity/uninterruptedness",
    "AP.03.c.05.a": "Discontinuity/interrupted sequence/condition",
    "AP.04": "Number",
    "AP.04.a": "One",
    "AP.04.a.01": "Unity/undividedness",
    "AP.04.a.02": "Firstness",
    "AP.04.b": "Two",
    "AP.04.b.01": "Division into two",
    "AP.04.c": "Three",
    "AP.04.d": "Four",
    "AP.04.e": "Five",
    "AP.04.f": "Ten",
    "AP.04.g": "Eleven to ninety-nine",
    "AP.04.h": "Hundred and over",
    "AP.04.i": "Plurality",
    "AP.04.i.01": "Fewness",
    "AP.04.i.02": "Great number, numerousness",
    "AP.04.j": "Mathematics",
    "AP.04.k": "Mathematical number/quantity",
    "AP.04.k.01": "Numerical arrangement",
    "AP.04.l": "Mathematical notation/symbol",
    "AP.04.m": "Enumeration/reckoning/calculation",
    "AP.04.n": "Arithmetic",
    "AP.04.o": "Algebra",
    "AP.04.p": "Arithmetic/algebraic operations",
    "AP.04.q": "Ratio/proportion",
    "AP.04.r": "Calculus",
    "AP.04.s": "Geometry",
    "AP.04.s.01": "Point",
    "AP.04.s.02": "Line",
    "AP.04.s.03": "Curve",
    "AP.04.s.04": "Angle",
    "AP.04.s.05": "Shape/figure",
    "AP.04.t": "Graph/diagram",
    "AP.04.u": "Probability/statistics",
    "AP.04.v": "Computing/information technology",
    "AP.04.v.01": "Hardware",
    "AP.04.v.01.a": "Computer",
    "AP.04.v.02": "Software",
    "AP.04.v.03": "Programming language",
    "AP.04.v.04": "Data",
    "AP.05": "Measurement",
    "AP.05.a": "Measurement of length",
    "AP.05.b": "Measurement of area",
    "AP.05.c": "Scientific measurement of volume",
    "AP.05.c.01": "Measure(s) of capacity",
    "AP.05.c.01.a": "Amount defined by capacity",
    "AP.05.d": "Measuring instrument",
    "AP.05.e": "Measurement by weighing",
    "AP.05.e.01": "Equipment for weighing",
    "AP.06": "Quantity",
    "AP.06.a": "Greatness of quantity/amount/degree",
    "AP.06.a.01": "High/intense degree",
    "AP.06.b": "Sufficient quantity/amount/degree",
    "AP.06.b.01": "Abundance",
    "AP.06.b.02": "Excessive amount/degree",
    "AP.06.c": "Increase in quantity/amount/degree",
    "AP.06.c.01": "Addition/supplementation",
    "AP.06.d": "Smallness of quantity/amount/degree",
    "AP.06.e": "Insufficiency",
    "AP.06.f": "Decrease/reduction in quantity/amount/degree",
    "AP.07": "Wholeness",
    "AP.07.a": "Completeness",
    "AP.07.b": "The whole/all",
    "AP.07.c": "State/quality of being simple/unmixed/uncompounded",
    "AP.07.d": "Incompleteness",
    "AP.07.d.01": "Part of whole",
    "AP.07.d.01.a": "That which is left/remainder",
    "AP.07.e": "Mutual relation of parts to whole",
    "AP.07.e.01": "Incorporation/inclusion",
    "AP.07.e.02": "Condition/state of being combined",
    "AP.07.e.03": "Condition/state of being mixed/blended",
    "AP.07.e.04": "Condition/fact of uniting/being united",
    "AP.07.e.05": "Fact/action of being joined/joining",
    "AP.07.e.05.a": "Fact/action of being connected/connecting",
    "AP.07.e.05.b": "Attachment",
    "AP.07.e.06": "Fastening",
    "AP.07.e.06.a": "Binding/tying",
    "AP.07.e.06.b": "Condition of being fast bound/firmly fixed",
    "AP.07.e.07": "Separation",
    "AP.07.e.07.a": "Separation/breaking up into constituent parts",
    "AP.07.e.07.b": "Action of dividing/divided condition",
    "AP.07.e.07.c": "Separation/detachment, loosening/unfastening",
    "AQ": "The supernatural",
    "AQ.01": "The paranormal",
    "AQ.02": "The occult",
    "AQ.02.a": "Spiritualism",
    "AQ.02.b": "Sorcery/witchcraft/magic",
    "AQ.02.b.01": "Sorcerer/magician",
    "AQ.02.b.01.a": "Witch",
    "AQ.02.b.02": "Non-European magic (miscellaneous)",
    "AQ.02.b.03": "Enchantment/casting spells",
    "AQ.03": "Supernatural being",
    "AQ.03.a": "Evil spirit/demon",
    "AQ.03.b": "Ghost/phantom",
    "AQ.03.c": "Fairy/elf",
    "AQ.03.d": "Mythical creature/object",
    "AQ.03.e": "Hybrid creature/monster",
    "AQ.03.f": "Malignant monster",
    "AQ.04": "Deity",
    "AQ.04.a": "Christian God",
    "AQ.04.a.01": "Trinity",
    "AQ.04.a.01.a": "The Son/Christ",
    "AQ.04.a.02": "Nature/attributes of God",
    "AQ.04.a.03": "Activities of God",
    "AQ.04.a.04": "Mary",
    "AQ.04.b": "Classical deity",
    "AQ.04.c": "Other deities",
    "AQ.04.d": "Angel",
    "AQ.04.e": "A devil",
    "AQ.04.e.01": "The Devil/Satan",
    "AQ.04.f": "Heaven",
    "AQ.04.g": "Hell",
    "AR": "The mind",
    "AR.01": "Mental capacity",
    "AR.02": "Spirituality, soul",
    "AR.03": "Intellect",
    "AR.03.a": "Animality in people",
    "AR.04": "Consciousness",
    "AR.04.a": "Self-consciousness",
    "AR.05": "Character, disposition, mood",
    "AR.06": "Psychology",
    "AR.06.a": "Psychological actions and processes",
    "AR.06.b": "Social and group psychology",
    "AR.06.c": "Developmental psychology",
    "AR.06.c.01": "Psychological memory",
    "AR.06.d": "Psychology of perception",
    "AR.06.d.01": "Gestalt psychology",
    "AR.06.e": "Cognitive psychology",
    "AR.06.e.01": "Association of ideas",
    "AR.06.f": "Psychology of personality",
    "AR.06.g": "Faculty psychology",
    "AR.06.g.01": "Phrenology",
    "AR.06.h": "Behaviourism",
    "AR.06.i": "Experimental psychology",
    "AR.06.i.01": "Stimulus-response",
    "AR.06.j": "Psychology of emotion",
    "AR.07": "Psychoanalysis",
    "AR.07.a": "Theories of Freud",
    "AR.07.b": "Theories of Jung",
    "AR.07.c": "Theories of Adler",
    "AR.07.d": "Libido",
    "AR.07.d.01": "Psychological obsession/complex",
    "AR.08": "Thinking, thought",
    "AR.08.a": "Contemplation, reflection, consideration",
    "AR.09": "Perception, cognition",
    "AR.09.a": "Recognition",
    "AR.10": "Intuition",
    "AR.11": "Ideas",
    "AR.11.a": "Topic, subject, concern",
    "AR.12": "Imagination",
    "AR.12.a": "A vision",
    "AR.12.b": "Day-dream, reverie",
    "AR.12.c": "Fancy, fantastic notion",
    "AR.12.d": "Deceptive fancy, illusion",
    "AR.13": "Idealism",
    "AR.13.a": "Ideal place",
    "AR.13.b": "Romanticism",
    "AR.14": "Creativity",
    "AR.15": "Lack of imagination",
    "AR.16": "Understanding",
    "AR.17": "Intelligence, cleverness",
    "AR.17.a": "High intelligence, genius",
    "AR.17.b": "Sharpness, shrewdness, insight",
    "AR.17.c": "Wit, wittiness",
    "AR.18": "Wisdom, sagacity",
    "AR.18.a": "Wise man, sage",
    "AR.18.b": "Prudence, discretion",
    "AR.19": "Reason, reasoning",
    "AR.19.a": "Common sense",
    "AR.19.b": "Inference",
    "AR.20": "Lack of reasoning, illogicality",
    "AR.21": "Misleading argument, sophistry",
    "AR.21.a": "Hair-splitting, quibbling",
    "AR.22": "Lack of understanding",
    "AR.23": " Irrationality",
    "AR.24": "Stupidity",
    "AR.24.a": "Oafishness",
    "AR.24.b": "Foolishness, folly",
    "AR.25": "Absurdity, incongruity",
    "AR.26": "Weakness of intellect",
    "AR.26.a": "Simple-mindedness",
    "AR.26.b": "Madness, extreme folly",
    "AR.26.c": "Confusion, muddle-headedness",
    "AR.27": "Stupid/foolish/inadequate person",
    "AR.28": "Intelligibility",
    "AR.29": "Meaning",
    "AR.30": "Explanation, exposition",
    "AR.30.a": "Paraphrase",
    "AR.30.b": "Interpretation",
    "AR.30.c": "Translation",
    "AR.31": "Linguistic ambiguity",
    "AR.32": "Unintelligibility, obscurity",
    "AR.32.a": "Inexpressibility",
    "AR.33": "Absence of meaning",
    "AR.33.a": "Nonsense, rubbish",
    "AR.33.a.01": "Unintelligible language, gibberish",
    "AR.33.a.02": "Empty, idle talk",
    "AR.33.a.03": "Insincere/pretentious talk",
    "AR.34": "Misinterpretation",
    "AR.34.a": "Distortion/perversion of meaning",
    "AR.35": "Memory, keeping in mind",
    "AR.35.a": "Memorization",
    "AR.35.b": "Mnemonics",
    "AR.35.c": "Reminder, commemoration, memento",
    "AR.35.d": "Retrospection, reminiscence",
    "AR.35.e": "Faulty recollection, forgetting",
    "AR.35.f": "Effacement, obliteration",
    "AR.35.g": "Cancellation, revocation",
    "AR.36": "Knowledge",
    "AR.36.a": "Experience",
    "AR.36.b": "Scholarly knowledge, erudition",
    "AR.36.b.01": "Learned person, scholar",
    "AR.36.c": "Branch of knowledge",
    "AR.36.c.01": "Humanistic studies",
    "AR.36.c.02": "Science",
    "AR.36.d": "Saying, maxim, proverb",
    "AR.36.e": "Pedantry",
    "AR.37": "Ignorance",
    "AR.37.a": "Illiteracy",
    "AR.37.b": "Philistinism",
    "AR.37.c": "Inexperience",
    "AR.37.d": "The unknown",
    "AR.38": "Truth, validity, correctness",
    "AR.38.a": "Accuracy, precision",
    "AR.39": "Truthfulness, veracity",
    "AR.39.a": "Sincerity",
    "AR.40": "Exaggeration",
    "AR.41": "Disregard for truth, falsehood",
    "AR.41.a": "Lack of truth, falsity, error",
    "AR.41.b": "Inaccuracy, incorrectness",
    "AR.41.b.01": "Incorrectness of language",
    "AR.41.c": "Error in belief/opinion",
    "AR.41.d": "Fabrication of statement, fiction",
    "AR.42": "Deceit, deception, trickery",
    "AR.42.a": "Snare, trap, entanglement",
    "AR.42.b": "Evasion, shiftiness",
    "AR.42.c": "Cheating, fraud",
    "AR.42.c.01": "A charlatan, fraudster",
    "AR.42.d": "Trickery, duping, gullibility",
    "AR.42.e": "Forgery, falsification",
    "AR.42.f": "Collusion, intrigue, conspiracy",
    "AR.42.g": "Delusion",
    "AR.42.g.01": "Self-deception",
    "AR.42.h": "Dissimulation, pretence",
    "AR.42.h.01": "Hypocrisy",
    "AR.42.h.02": "Insincerity",
    "AR.42.i": "Misrepresentation",
    "AR.43": "Secrecy, concealment",
    "AR.43.a": "Stealthy action, stealth",
    "AR.43.b": "A profound secret, mystery",
    "AR.43.c": "Puzzle, enigma, riddle",
    "AR.43.d": "Code, cipher",
    "AR.44": "Hiding, concealing ",
    "AR.44.a": "Keeping from knowledge",
    "AR.44.a.01": "Keeping from publication, censorship",
    "AR.44.b": "Means of concealment, disguise",
    "AR.44.c": "Secret place, hiding place",
    "AR.44.d": "Privacy",
    "AR.45": "Belief, opinion",
    "AR.45.a": "School of thought, ideology",
    "AR.45.b": "Belief, trust, confidence",
    "AR.45.c": "Act of convincing, conviction",
    "AR.45.d": "Credulity",
    "AR.45.e": "Expressed belief, opinion",
    "AR.45.f": "Extreme opinion, dogmatism",
    "AR.45.g": "Bias, prejudice, intolerance",
    "AR.46": "Supposition, surmise, presumption",
    "AR.46.a": "Conjecture, guessing, speculation",
    "AR.46.b": "Hypothesis, theory",
    "AR.46.c": "Suggestion, proposal",
    "AR.47": "Disbelief, incredulity",
    "AR.47.a": "Uncertainty, doubt, hesitation",
    "AR.47.b": "Lack of confidence, distrust, suspicion",
    "AR.47.c": "Perplexity, bewilderment",
    "AR.47.d": "State of uncertainty, suspense",
    "AR.48": "Insecure knowledge, uncertainty",
    "AR.48.a": "Unreliability",
    "AR.48.b": "Impossibility, improbability",
    "AR.48.c": "Possibility, probability",
    "AR.49": "Absence of doubt, confidence",
    "AR.49.a": "Reliability",
    "AR.50": "Expectation",
    "AR.50.a": "Surprise, unexpectedness",
    "AR.50.a.01": "Suddenness",
    "AR.50.b": "Hope",
    "AR.50.b.01": "Aspiration, ambition",
    "AR.50.b.02": "Optimism",
    "AR.50.b.02.a": "Doctrine of human perfectibility",
    "AR.50.c": "Promise, ground of hope",
    "AR.50.d": "Confident hope, trust",
    "AR.50.e": "Disappointment",
    "AR.50.f": "Despair, hopelessness",
    "AR.50.f.01": "Pessimism",
    "AR.51": "Feeling of wonder, astonishment, awe",
    "AR.52": "Foresight, foreknowledge",
    "AR.52.a": "Prediction, foretelling",
    "AR.52.b": "Divination",
    "AR.52.b.01": "An omen, sign, portent",
    "AR.52.b.02": "Interpretation of dreams",
    "AR.52.b.03": "Casting of lots, sortilege",
    "AR.52.b.04": "Crystal-gazing",
    "AR.52.b.05": "Palmistry",
    "AR.53": "Philosophy",
    "AR.53.a": "Ancient Greek philosophy",
    "AR.53.b": "Scholasticism",
    "AR.53.c": "Metaphysics",
    "AR.53.d": "Epistemology",
    "AR.53.e": "Idealism",
    "AR.53.f": "Philosophy of aesthetics",
    "AR.53.g": "Existentialism",
    "AR.53.h": "Moral philosophy",
    "AR.53.i": "Pragmatism",
    "AR.53.j": "Logic",
    "AR.53.j.01": "Predicate/propositional logic",
    "AR.53.k": "Philosophy of language",
    "AS": "Attention, judgment, curiosity",
    "AS.01": "Attention",
    "AS.01.b": "Concentration",
    "AS.02": "Inattention",
    "AS.03": "Distraction, confusion, bewilderment",
    "AS.04": "Enquiry",
    "AS.04.a": "Investigation, inspection",
    "AS.04.b": "Secret observation, spying",
    "AS.04.c": "Discovery",
    "AS.04.c.01": "Research",
    "AS.04.d": "Instrument for detection",
    "AS.04.e": "Invention, devising",
    "AS.04.f": "Comparison, contrast",
    "AS.04.g": "Answer",
    "AS.05": "Testing",
    "AS.05.a": "Attestation, witness, evidence",
    "AS.05.b": "Qualification, condition, reservation",
    "AS.05.c": "Debate, disputation, argument",
    "AS.05.d": "Proof",
    "AS.05.e": "Solution to problem",
    "AS.06": "Accusation, charge",
    "AS.06.a": "Disproof",
    "AS.06.b": "Judgement, decision",
    "AS.07": "Evaluation, estimation, appraisal",
    "AS.08": "Advice",
    "AS.09": "Discernment, discrimination",
    "AS.09.a": "Criticism, censure",
    "AS.09.b": "Absence of prejudice",
    "AS.09.c": "Misjudgement",
    "AS.10": "Importance, influence",
    "AS.11.a": "Unimportance, triviality",
    "AS.12": "Esteem",
    "AS.12.a": "Favour",
    "AS.12.b": "Respect",
    "AS.12.b.01": "Reverence",
    "AS.12.c": "Admiration",
    "AS.12.d": "Approval/sanction",
    "AS.12.d.01": "Popularity",
    "AS.12.e": "Commendation/praise",
    "AS.12.e.01": "Recommendation",
    "AS.12.e.02": "Compliment",
    "AS.12.e.03": "Congratulation",
    "AS.12.e.04": "Applause",
    "AS.12.f": "Flattery/flattering",
    "AS.13": "Reputation",
    "AS.13.a": "Fame/renown",
    "AS.13.a.01": "Famous/eminent person",
    "AS.13.b": "High reputation, honour",
    "AS.13.b.01": "Exaltation, glorification",
    "AS.13.c": "Good repute",
    "AS.13.c.01": "Honour",
    "AS.14": "Contempt",
    "AS.14.a": "Derision/ridicule/mockery",
    "AS.14.a.01": "Banter/good-humoured ridicule",
    "AS.14.a.02": "Jeering/taunting/scoffing",
    "AS.14.b": "Disrespect, disfavour, insult",
    "AS.14.b.01": "Irreverence",
    "AS.14.b.02": "Insult",
    "AS.14.b.03": "Disfavour",
    "AS.14.b.04": "Unpopularity",
    "AS.14.c": "Disapproval, censure",
    "AS.14.c.01": "Criticism, being critical",
    "AS.14.c.02": "Dispraise",
    "AS.14.d": "Blame, reproach, rebuke",
    "AS.14.e": "Denunciation, invective",
    "AS.15": "Disrepute",
    "AS.15.a": "Infamy/notoriety",
    "AS.15.b": "Damage to reputation",
    "AS.15.b.01": "Slander, calumny",
    "AS.15.c": "Disgrace, dishonour",
    "AS.15.d": "Obscurity/ingloriousness",
    "AS.15.e": "Ignobleness/baseness",
    "AS.16": "Aesthetics",
    "AS.17": "Good taste",
    "AS.17.a": "Refinement",
    "AS.17.a.01": "Fastidiousness",
    "AS.17.a.02": "Elegance",
    "AS.18": "Bad taste",
    "AS.18.a": "Flashiness/gaudiness",
    "AS.19": "Fashionableness",
    "AS.19.a": "Unfashionableness",
    "AS.20": "Beauty, pleasing appearance",
    "AS.21": "Beautification",
    "AS.21.a": "Ornamentation, jewellery",
    "AS.21.b": "Beautification of the person",
    "AS.21.b.01": "Hairdressing",
    "AS.22": "Absence of beauty, ugliness",
    "AS.22.a": "Disfigurement",
    "AT": "Goodness and badness",
    "AT.01": "Goodness, acceptability",
    "AT.02": "Mediocrity",
    "AT.03": "Improvement",
    "AT.04": "Superiority, excellence, perfection",
    "AT.05": "Worth, merit",
    "AT.06": "Badness/evil",
    "AT.06.a": "Offensiveness",
    "AT.07": "Deterioration",
    "AT.07.a": "Relapse",
    "AT.08": "Extreme evil, unpardonableness",
    "AT.09": "Inferiority/baseness",
    "AT.10": "Roguery, dissoluteness",
    "AT.10.a": "Ruffianly conduct",
    "AT.11": "Wretchedness/baseness",
    "AT.12": "Villainy",
    "AT.13": "Foulness, filth",
    "AT.14": "Accursedness, cursing",
    "AT.15": "Wrongdoing",
    "AT.15.a": "Sinfulness",
    "AT.15.b": "Guilt",
    "AT.15.c": "Criminality",
    "AT.15.d": "Immorality",
    "AT.15.e": "Leading astray",
    "AT.15.f": "Corruption",
    "AT.15.g": "Misbehaviour",
    "AT.15.h": "Undutifulness",
    "AT.15.i": "Unjustness",
    "AT.15.j": "Unfittingness",
    "AT.16": "Treachery, treason",
    "AT.16.a": "Disloyalty",
    "AT.17": "Dishonesty",
    "AT.18": "Harmfulness/injury",
    "AT.19": "Mischievousness",
    "AT.20": "Spitefulness, ill-will",
    "AT.21": "Harshness, cruelty",
    "AU": "Emotion",
    "AU.01": "Emotions, mood",
    "AU.01.a": "State of feeling, mood",
    "AU.01.b": "Manifestation of emotion",
    "AU.02": "Capacity for emotion",
    "AU.02.a": "Sentimentality",
    "AU.03": "Absence of emotion",
    "AU.04": "Intense emotion",
    "AU.05": "Excitement",
    "AU.05.a": "Inspiration",
    "AU.05.b": "Spiritedness/liveliness",
    "AU.05.c": "Impetuosity",
    "AU.05.d": "Impatience",
    "AU.06": "Calmness",
    "AU.07": "Meekness, patience",
    "AU.07.a": "Patience",
    "AU.08": "Pleasure",
    "AU.09": "Smiling",
    "AU.10": "Contentment/satisfaction",
    "AU.10.a": "Self-satisfaction",
    "AU.11": "Happiness",
    "AU.11.a": "Consolation, relief",
    "AU.11.b": "Rapture/ecstasy",
    "AU.11.c": "Rejoicing/exultation",
    "AU.12": "Cheerfulness",
    "AU.12.a": "Merriment",
    "AU.13": "Laughter",
    "AU.13.a": "Cause of laughter, joking",
    "AU.14": "Suffering",
    "AU.14.a": "Mental anguish/torment",
    "AU.14.b": "Broken-heartedness",
    "AU.15": "Sorrow, grief",
    "AU.15.a": "Expression of grief",
    "AU.15.a.01": "Moaning/groaning",
    "AU.15.a.02": "Weeping",
    "AU.15.a.03": "Sighing",
    "AU.16": "Regret, remorse",
    "AU.17": "Misery",
    "AU.18": "Anxiety, worry",
    "AU.18.a": "Worry",
    "AU.18.b": "Anxiety",
    "AU.19": "Shock",
    "AU.20": "Harassment, oppression",
    "AU.21": "Dejection, depression, melancholy",
    "AU.21.a": "Melancholy",
    "AU.21.b": "Seriousness/solemnity",
    "AU.22": "Displeasure",
    "AU.22.a": "Discontent",
    "AU.22.b": "Complaint",
    "AU.23": "Annoyance, vexation",
    "AU.24": "Weariness, tedium",
    "AU.25": "Anger",
    "AU.25.a": "Furious anger, rage",
    "AU.25.b": "Irritation",
    "AU.25.c": "Irascibility",
    "AU.26": "Ill-humour",
    "AU.27": "Love",
    "AU.27.a": "Liking",
    "AU.27.b": "Loved one",
    "AU.27.c": "Terms of endearment",
    "AU.27.d": "Affection, tenderness",
    "AU.28": "Manifestations of affection",
    "AU.28.a": "Embrace",
    "AU.28.b": "Kiss",
    "AU.29": "Amorous love",
    "AU.29.a": "Love-affair",
    "AU.29.b": "A lover",
    "AU.29.c": "Courtship",
    "AU.29.d": "Flirtation",
    "AU.30": "Friendship",
    "AU.31": "Hatred",
    "AU.31.a": "Dislike",
    "AU.31.a.01": "Disgust",
    "AU.32": "Hostility, enmity",
    "AU.32.a": "Enemy",
    "AU.32.b ": "Quarrel/falling out",
    "AU.33": "Indifference",
    "AU.34": "Compassion",
    "AU.34.a": "Pitilessness",
    "AU.35": "Jealousy, envy",
    "AU.36": "Gratitude",
    "AU.36.a": "Ingratitude",
    "AU.37": "Pride, arrogance",
    "AU.37.a": "Arrogance",
    "AU.37.b": "Impudence, shamelessness",
    "AU.37.c": "Proper pride/self-respect",
    "AU.37.d": "Haughtiness",
    "AU.37.e": "Pomposity",
    "AU.37.f": "Self-importance",
    "AU.37.g": "Complacency",
    "AU.37.h": "Conceit",
    "AU.37.i": "Vanity",
    "AU.38": "Vainglory, bravado",
    "AU.38.a": "Boasting",
    "AU.38.b": "Bravado",
    "AU.39": "Ostentation, display",
    "AU.39.a": "Ceremony",
    "AU.40": "Humility, shame",
    "AU.40.a": "Humiliation",
    "AU.40.b": "Shame",
    "AU.41": "Modesty",
    "AU.41.a": "Shyness",
    "AU.42": "Servility",
    "AU.43": "Fear",
    "AU.43.a": "Apprehensiveness",
    "AU.43.a.01": "Nervousness/uneasiness",
    "AU.43.a.02": "Timidity",
    "AU.44": "Dismay",
    "AU.45": "Cowardice",
    "AU.46": "Source of fear",
    "AU.46.a": "Intimidation",
    "AU.47": "Courage, spirit, daring",
    "AU.47.a": "Heroism, valour",
    "AU.47.a.01": "Chivalry",
    "AU.47.b": "Confidence",
    "AU.47.c": "Fearlessness",
    "AU.47.d": "Encouragement",
    "AV": "Will",
    "AV.01": "Free will",
    "AV.01.a": "Choice, choosing",
    "AV.01.b": "Necessity",
    "AV.01.b.01": "Fate, destiny",
    "AV.02": "Wish/inclination",
    "AV.02.a": "Willingness",
    "AV.02.a.01": "Unwillingness",
    "AV.02.b": "Desire",
    "AV.02.b.01": "Aspiration/ambition",
    "AV.03": "Intention",
    "AV.03.a": "Planning",
    "AV.03.a.01": "Plotting",
    "AV.04": "Decision",
    "AV.04.a": "Resolution, determination",
    "AV.04.b": "Constancy",
    "AV.04.b.01": "Perseverance",
    "AV.04.b.02": "Obstinacy, stubbornness",
    "AV.04.c": "Irresolution/inconstancy",
    "AV.05": "Motivation",
    "AV.05.a": "Persuasion",
    "AW": "Possession/ownership",
    "AW.01": "Owning",
    "AW.01.a": "Possessions",
    "AW.02": "Non-possession",
    "AW.03": "Wealth",
    "AW.04": "Poverty",
    "AW.04.a": "Begging, beggar",
    "AW.05": "Sharing",
    "AW.06": "Acquisition",
    "AW.06.a": "Not obtaining",
    "AW.06.b": "Receiving",
    "AW.07": "Loss",
    "AW.07.a": "Taking away",
    "AW.08": "Retaining",
    "AW.09": "Frugality, meanness",
    "AW.10": "Relinquishing",
    "AW.10.a": "Prodigality",
    "AW.11": "Giving",
    "AW.11.a": "Gift",
    "AW.11.b": "Lavishness",
    "AW.11.c": "Distributing, sharing out",
    "AW.12": "Lending",
    "AW.13": "Giving back, restitution",
    "AW.14": "Offering",
    "AW.15": "Taking",
    "AW.15.a": "Seizing, capture",
    "AW.15.b": "Extortion",
    "AW.16": "Taking surreptitiously, theft",
    "AW.16.a": "Stealing, theft",
    "AW.16.b": "Burglary",
    "AW.16.c": "Robbery, piracy, raiding",
    "AW.16.c.01": "Piracy",
    "AW.16.c.02": "Kidnapping",
    "AW.16.c.03": "Plagiarism",
    "AW.16.c.04": "Swindling",
    "AW.17": "Thief, robber, swindler",
    "AW.18": "Stolen goods",
    "AW.19": "Borrowing",
    "AW.20": "Supply",
    "AW.20.a": "Storage",
    "AX": "Language",
    "AX.01": "A language",
    "AX.01.a": "Dialect",
    "AX.01.b": "Register",
    "AX.02": "Languages of the world",
    "AX.02.a": "Indo-Hittite languages",
    "AX.02.b": "Pidgins and creoles",
    "AX.03": "Speech",
    "AX.03.a": "Speaker",
    "AX.03.b": "Manner of speaking",
    "AX.03.b.01": "Accent",
    "AX.04": "Narration, description",
    "AX.05": "Interruption",
    "AX.06": "Speech-making",
    "AX.06.a": "Recitation",
    "AX.06b": "Rhetoric",
    "AX.07": "Conversation",
    "AX.08": "Monologue",
    "AX.09": "Talkativeness",
    "AX.10": "Taciturnity",
    "AX.11": "Imperfect speech",
    "AX.12": "Requesting",
    "AX.13": "Protest, remonstrance",
    "AX.14": "Agreement, consent",
    "AX.15": "Promise, pledge",
    "AX.16": "Linguistics",
    "AX.16.a": "Grammar",
    "AX.16.a.01": "Part of speech",
    "AX.16.a.02": "Morphology",
    "AX.16.a.03": "Syntax",
    "AX.16.a.04": "Grammatical categories",
    "AX.17": "Semantics",
    "AX.17.a": "Semiotics",
    "AX.18": "Phonetics and phonology",
    "AX.19": "Words and phrases",
    "AX.20": "Lexicography",
    "AX.21": "Naming",
    "AX.21.a": "Anonymity",
    "AX.22": "Statement, declaration",
    "AX.23": "Agreement, assent",
    "AX.24": "Denial, dissent",
    "AX.24.a": "Objection",
    "AX.25": "Refusal",
    "AX.26": "Malediction",
    "AX.26.a": "Oaths",
    "AY": "Society",
    "AY.01": "Kinship/relationship",
    "AY.01.a": "Relations/kindred",
    "AY.01.b": "Family",
    "AY.01.c": "Clan",
    "AY.01.d": "Tribe",
    "AY.01.e": "Kinsman/relation",
    "AY.01.e.01": "Parent",
    "AY.01.e.01.a": "Father",
    "AY.01.e.01.b": "Mother",
    "AY.01.e.02": "Child",
    "AY.01.e.02.a": "Son",
    "AY.01.e.02.b": "Daughter",
    "AY.01.e.03": "Grandparent",
    "AY.01.e.04": "Grandchild",
    "AY.01.e.05": "Sibling",
    "AY.01.e.05.a": "Brother",
    "AY.01.e.05.b": "Sister",
    "AY.01.e.06": "Uncle",
    "AY.01.e.07": "Aunt",
    "AY.01.e.08": "Nephew/niece",
    "AY.01.e.09": "Cousin",
    "AY.01.e.10": "Ancestor",
    "AY.01.e.11": "Descendant",
    "AY.01.f": "Lineage/descent",
    "AY.01.f.01": "Genealogy as study",
    "AY.01.g": "Marriage/wedlock",
    "AY.01.g.01": "Married woman",
    "AY.01.g.02": "Married man",
    "AY.01.g.03": "Types of marriage custom/practice",
    "AY.01.g.04": "A marriage",
    "AY.01.g.05": "Fitness for marriage",
    "AY.01.g.06": "Seeking marriage",
    "AY.01.g.07": "Match-making",
    "AY.01.g.08": "Proposal of marriage",
    "AY.01.g.09": "Betrothal",
    "AY.01.g.10": "Action/fact of marrying",
    "AY.01.g.11": "Wedding/nuptials",
    "AY.01.g.11.01": "Marriage-vows/bonds",
    "AY.01.g.11.02": "Music/song/bells",
    "AY.01.g.11.03": "Wedding festivities",
    "AY.01.g.11.04": "Gifts and payments",
    "AY.01.g.11.05": "Time after marriage",
    "AY.01.g.12": "Remarriage",
    "AY.01.g.13": "Unmarried person(s)",
    "AY.01.g.13.01": "Unmarried woman",
    "AY.01.g.13.02": "Unmarried man",
    "AY.01.g.14": "Widow/widower",
    "AY.01.g.15": "Divorce/dissolution",
    "AY.02": "Study of society",
    "AY.03": "Society in relation to customs/values/beliefs",
    "AY.03.a": "Customs/values/beliefs of a society/group",
    "AY.03.b": "Civilization",
    "AY.03.b.01": "Lack of civilization",
    "AY.03.c": "A civilization/culture",
    "AY.04": "Social relations",
    "AY.04.a": "Association/fellowship/companionship",
    "AY.04.a.01": "A company/body of persons",
    "AY.04.a.02": "A companion/associate",
    "AY.04.b": "Co-operation",
    "AY.04.c": "Association for a common purpose",
    "AY.04.c.01": "Meeting/assembling for common purpose",
    "AY.04.d": "An association/society/organization",
    "AY.04.d.01": "Types of association/society/organization",
    "AY.04.d.02": "Specific societies/organizations",
    "AY.04.d.03": "Secret society",
    "AY.04.e": "Party/faction",
    "AY.04.f": "Lack of social communication/relations",
    "AY.04.f.01": "Solitude/solitariness",
    "AY.04.f.02": "Retirement/seclusion",
    "AY.04.f.03": "Separation/isolation",
    "AY.04.f.04": "Exclusion from society",
    "AY.05": "Social attitudes",
    "AY.05.a": "Philanthropy",
    "AY.05.b": "Misanthropy",
    "AY.05.c": "Public-spiritedness",
    "AY.05.d": "Patriotism",
    "AY.05.d.01": "Nationalism",
    "AY.05.d.02": "Liking for/sympathy with other nations",
    "AY.05.d.03": "Fear/dislike of other nations",
    "AY.05.e": "Racial attitudes",
    "AY.06": "Social class",
    "AY.06.a": "Nobility",
    "AY.06.a.01": "Aristocracy/upper class",
    "AY.06.a.02": "Rank",
    "AY.06.a.02.a": "Royalty",
    "AY.06.a.02.b": "Duke/duchess",
    "AY.06.a.02.c": "Lord/lady",
    "AY.06.a.02.d": "Earl/count/countess",
    "AY.06.a.02.e": "Knight",
    "AY.06.a.02.f": "Knight's squire",
    "AY.06.a.02.g": "Raising to noble rank",
    "AY.06.a.02.h": "Divesting of rank/title",
    "AY.06.a.03": "Title",
    "AY.06.a.03.a": "Title/form of address for persons of rank",
    "AY.06.b": "The common people",
    "AY.06.b.01": "Specific ranks of common people",
    "AY.06.b.02": "Specific classes of common people",
    "AY.06.b.02.a": "Fashionable society",
    "AY.06.b.02.b": "Peasant/rustic",
    "AY.06.b.03": "Socially inferior person",
    "AY.06.b.04": "Low rank/condition",
    "AY.06.b.04.a": "Low/vulgar person",
    "AY.06.b.04.b": "Lout/boor",
    "AY.06.b.04.c": "The lowest class",
    "AY.06.b.04.d": "Outcast/untouchable",
    "AY.06.c": "Symbol of Rank",
    "AY.07": "Dissent",
    "AY.07.a": "Lack of peacefulness",
    "AY.07.b": "Contention/strife",
    "AY.07.c": "Quarrel/quarrelling",
    "AY.07.d": "Fighting",
    "AY.07.e": "Competition/rivalry",
    "AY.07.e.01": "Challenge/challenging",
    "AY.07.f": "Absence of dissension/peace",
    "AY.07.f.01": "Bringing about concord/peace",
    "AZ": "Inhabiting and dwelling",
    "AZ.01": "Inhabiting temporarily",
    "AZ.01.a": "Haunting/resorting",
    "AZ.01.b": "Camping/encamping",
    "AZ.01.c": "Exile/state of",
    "AZ.02": "Providing with dwelling",
    "AZ.03": "Removing from dwelling",
    "AZ.04": "Furnishing with inhabitants",
    "AZ.04.a": "Colonizing",
    "AZ.04.b": "Migration",
    "AZ.04.b.01": "Immigration",
    "AZ.04.b.02": "Emigration",
    "AZ.05": "Inhabitant",
    "AZ.05.a": "Population",
    "AZ.05.b": "Temporary inhabitant",
    "AZ.05.c": "Country dweller",
    "AZ.05.d": "Town-/city-dweller",
    "AZ.05.e": "Colonist/settler",
    "AZ.05.f": "Migrant",
    "AZ.05.g": "Exile",
    "AZ.06": "Inhabited place",
    "AZ.06.a": "A land/country",
    "AZ.06.a.01": "Part of country/district",
    "AZ.06.b": "Country as opposed to town",
    "AZ.06.c": "Town and country",
    "AZ.06.d": "Town as opposed to country",
    "AZ.06.d.01": "Town or city",
    "AZ.06.d.01.a": "Part of town/city",
    "AZ.06.d.01.b": "City",
    "AZ.06.d.01.c": "Town",
    "AZ.06.d.01.d": "Village",
    "AZ.06.e": "Dwelling-place/abode",
    "AZ.06.e.01": "Accommodation/lodging",
    "AZ.06.e.01.a": "Public lodging-places",
    "AZ.06.e.02": "Institutional homes",
    "AZ.06.e.03": "Camp/encampment",
    "AZ.06.e.04": "Place of resort",
    "AZ.06.e.05": "A dwelling",
    "AZ.06.e.05.a": "A house",
    "AZ.06.e.05.b": "Official residence",
    "AZ.06.e.05.c": "Dwelling of king/ruler",
    "AZ.06.e.05.d": "Hut/hovel",
    "AZ.06.e.05.e": "Tent",
    "AZ.06.f": "A building",
    "AZ.06.f.01": "Public building",
    "AZ.06.f.02": "Parts of building",
    "AZ.06.f.02.a": "Framework of building",
    "AZ.06.f.02.b": "Wall of building",
    "AZ.06.f.02.c": "Roof",
    "AZ.06.f.02.d": "Floor",
    "AZ.06.f.02.e": "Window/door",
    "AZ.06.f.02.f": "Room",
    "AZ.06.f.02.g": "Passage/corridor",
    "AZ.06.f.02.h": "Stairs",
    "AZ.06.f.02.i": "Porches, balconies, etc",
    "AZ.06.f.03": "Outhouse(s)",
    "AZ.06.f.04": "Courtyard",
    "AZ.06.f.05": "Furniture and fittings",
    "AZ.06.f.05.a": "Table",
    "AZ.06.f.05.b": "Desk",
    "AZ.06.f.05.c": "Cupboard/cabinet",
    "AZ.06.f.05.d": "Chest of drawers",
    "AZ.06.f.05.e": "Stand",
    "AZ.06.f.05.f": "Seat",
    "AZ.06.f.05.g": "Support/rest",
    "AZ.06.f.05.h": "Bed",
    "AZ.06.f.05.i": "Household linen",
    "AZ.06.f.05.j": "Covers/hangings",
    "AZ.06.f.05.k": "Screen",
    "AZ.06.f.05.l": "Wallcovering",
    "AZ.06.f.05.m": "Floor-covering",
    "BA": "Armed hostility",
    "BA.01": "War",
    "BA.01.a": "War as profession/skill",
    "BA.01.b": "Militarism",
    "BA.02": "Armed encounter",
    "BA.02.a": "Contending in battle",
    "BA.02.b": "Battlefield",
    "BA.03": "Victory",
    "BA.04": "Defeat",
    "BA.05": "Attack",
    "BA.05.a": "Charge",
    "BA.05.b": "Raid",
    "BA.05.c": "Invasion",
    "BA.05.d": "Action/state of siege/blockade",
    "BA.06": "Defence",
    "BA.06.a": "Action/duty of sentry/picket",
    "BA.06.b": "Holding out/making stand",
    "BA.06.c": "Defensive work(s)",
    "BA.06.c.01": "Fort/fortified town",
    "BA.06.c.02": "Castle/fortified building",
    "BA.06.c.03": "Palisade/stockade",
    "BA.06.c.04": "Defensive walls",
    "BA.06.c.05": "Gate",
    "BA.06.c.06": "Moat",
    "BA.06.c.07": "Earthwork/rampart",
    "BA.06.c.08": "Barricade",
    "BA.06.c.09": "Shelter/screen",
    "BA.07": "Military operations",
    "BA.07.a": "Manoeuvre",
    "BA.07.b": "Evolution",
    "BA.07.c": "Distribution of troops",
    "BA.07.c.01": "Formation",
    "BA.07.c.02": "Military position",
    "BA.08": "Drill/training",
    "BA.09": "Military organization",
    "BA.09.a": "Enlistment/recruitment",
    "BA.09.a.01": "Discharge from service",
    "BA.09.a.02": "Appointment to rank",
    "BA.09.b": "Logistics",
    "BA.09.b.01": "Quartering",
    "BA.09.c": "Ceremonial",
    "BA.09.d": "Orders",
    "BA.09.e": "Signals",
    "BA.09.f": "Insignia",
    "BA.10": "Military service",
    "BA.11": "Military power",
    "BA.12": "Armed forces",
    "BA.12.a": "The Army",
    "BA.12.a.01": "Branch of army",
    "BA.12.a.02": "Unit of army",
    "BA.12.a.03": "Part of army by position",
    "BA.12.a.04": "Group with special function/duty",
    "BA.13": "Warriors collectively",
    "BA.13.a": "Band of mercenaries",
    "BA.13.b": "Bands of guerrillas",
    "BA.13.c": "Paramilitary groups",
    "BA.13.d": "Life-guard/body-guard",
    "BA.13.e": "Comitatus/military followers",
    "BA.13.f": "Order of knights",
    "BA.14": "Warrior",
    "BA.14.a": "Attacker",
    "BA.14.b": "Defender",
    "BA.14.c": "Victor/conqueror",
    "BA.14.d": "Defeated/conquered",
    "BA.14.e": "Guerrilla",
    "BA.14.f": "Member of specific paramilitary group",
    "BA.14.g": "Life-guard/body-guard",
    "BA.14.h": "Armed retainer",
    "BA.14.i": "Member of order of knights, etc.",
    "BA.14.j": "Military person",
    "BA.14.k": "Soldier",
    "BA.14.k.01": "Soldier by nationality",
    "BA.14.k.02": "Soldier by branch of army",
    "BA.14.k.03": "Soldier by position",
    "BA.14.k.04": "Soldier by type of service",
    "BA.14.k.05": "Soldier with special duty",
    "BA.14.k.06": "Soldier who practises drill/evolution",
    "BA.14.k.07": "Common soldier",
    "BA.14.k.08": "Leader/commander",
    "BA.14.k.08.a": "Officer/soldier of rank",
    "BA.14.k.08.b": "Officer by rank",
    "BA.14.k.08.c": "Officer according to function",
    "BA.14.k.09": "Military servant",
    "BA.14.l": "Camp follower",
    "BA.14.m": "One who is armed",
    "BA.15": "Military equipment",
    "BA.15.a": "Weapon",
    "BA.15.a.01": "Club/stick",
    "BA.15.a.02": "Sharp weapon",
    "BA.15.a.02.a": "Spear/lance",
    "BA.15.a.02.b": "Axe",
    "BA.15.a.02.c": "Side-arms; sword, knife/dagger",
    "BA.15.a.03": "Engine of war",
    "BA.15.a.04": "Device for discharging missiles",
    "BA.15.a.04.a": "Archer's weapons",
    "BA.15.a.04.b": "Fire-arm generally",
    "BA.15.a.04.c": "Piece of artillery",
    "BA.15.a.04.d": "Small-arm",
    "BA.15.a.04.e": "Parts and fittings of fire-arms",
    "BA.15.a.05": "Missile",
    "BA.15.a.05.a": "Arrow",
    "BA.15.a.05.b": "Ammunition for fire-arms",
    "BA.15.a.05.c": "Guided/ballistic missile",
    "BA.15.a.06": "Explosive device",
    "BA.15.a.07": "Fire/radiation/chemical weapons",
    "BA.15.b": "Armour",
    "BA.15.b.01": "Body-armour",
    "BA.15.b.02": "Helmet",
    "BA.15.b.03": "Shield",
    "BA.15.c": "Arming/equipping with weapons",
    "BA.15.d": "Store of weapons/equipment",
    "BA.15.e": "Operation and use of weapons",
    "BA.15.e.01": "Stroke with weapon",
    "BA.15.e.02": "Cut of sharp weapon",
    "BA.15.e.02.a": "Cut/thrust with sword",
    "BA.15.e.02.b": "Use of knives",
    "BA.15.e.03": "Action of propelling missile",
    "BA.15.e.03.a": "Use of bow and arrow",
    "BA.15.e.03.b": "Discharge of fire-arms",
    "BA.15.e.04": "Use of mines and explosives",
    "BA.15.e.05": "Putting weapons/equipment out of action",
    "BA.15.f": "Production and development of arms",
    "BA.15.f.01": "Armourer",
    "BA.16": "Hostilities at sea",
    "BA.16.a": "Naval battle",
    "BA.16.b": "Operations/manoeuvres",
    "BA.16.c": "Administration and ceremonial",
    "BA.16.d": "Naval service",
    "BA.16.e": "Navy",
    "BA.16.e.01": "A naval force/fleet",
    "BA.16.f": "Seafaring warrior/naval man",
    "BA.16.f.01": "Leader/commander",
    "BA.16.f.02": "Naval officials",
    "BA.16.g": "Naval weapons and equipment",
    "BA.17": "Hostilities in the air",
    "BA.17.a": "Group/unit on operation",
    "BA.17.b": "Air force",
    "BA.17.c": "Airman",
    "BA.17.d": "Aircraft weapons/equipment",
    "BA.18": "Peace",
    "BA.18.a": "Pacification",
    "BA.18.a.01": "Peace treaty",
    "BA.18.a.02": "Disarmament",
    "BA.18.b": "Pacific character/disposition",
    "BA.18.c": "Neutrality",
    "BA.18.d": "Civilian life",
    "BB": "Authority",
    "BB.01": "Power",
    "BB.01.a": "Influence",
    "BB.02": "Command",
    "BB.02.a": "Command/bidding",
    "BB.03": "Control",
    "BB.03.a": "Person in control",
    "BB.04": "Strictness",
    "BB.05": "Lack of strictness",
    "BB.06": "Rule/government",
    "BB.06.a": "Misrule/misgovernment",
    "BB.06.b": "Oppression",
    "BB.06.c": "Rule/government of family/tribe",
    "BB.06.c.01": "Head of family/tribe/clan",
    "BB.06.d": "Rule of any class/persons",
    "BB.06.d.01": "Ruling class/group",
    "BB.06.e": "Autonomy",
    "BB.06.f": "Sole rule",
    "BB.06.g": "A/the system of government",
    "BB.06.g.01": "Monarchical government",
    "BB.06.g.02": "Government by the people/their delegates",
    "BB.06.g.03": "Systems based on specific principle",
    "BB.06.g.04": "Systems governed by person/body",
    "BB.06.g.05": "Direct rule/devolution/trusteeship/colonialism",
    "BB.06.g.06": "Centralized/regionalized systems",
    "BB.06.h": "Ruler/governor",
    "BB.06.h.01": "Joint ruler",
    "BB.06.h.02": "Absolute ruler",
    "BB.06.h.03": "Sovereign ruler/monarch",
    "BB.06.h.03.a": "King",
    "BB.06.h.03.b": "Queen",
    "BB.06.h.03.c": "Emperor",
    "BB.06.h.04": "Dynasty",
    "BB.06.h.05": "Regent",
    "BB.06.h.06": "Governor of province/dependency/colony",
    "BB.06.h.07": "Lord",
    "BB.06.h.08": "A/the government",
    "BB.06.h.08.a": "Head of government",
    "BB.06.h.08.b": "Government department/agency",
    "BB.06.h.08.c": "Government minister",
    "BB.06.h.08.d": "Civil service",
    "BB.06.h.08.e": "State/government/parliamentary papers",
    "BB.06.h.09": "Deliberative/legislative/administrative assembly",
    "BB.06.h.09.a": "Council of state",
    "BB.06.h.09.b": "Governing/legislative body of a nation/community",
    "BB.06.h.09.c": "Local government body",
    "BB.06.i": "Territorial jurisdiction/areas subject to",
    "BB.06.i.01": "Territory under a governor/official",
    "BB.06.i.02": "An administrative division of territory",
    "BB.06.j": "A/the state",
    "BB.06.k": "Politics",
    "BB.06.k.01": "Politician",
    "BB.06.k.02": "Discreditable political activity",
    "BB.06.k.03": "Party politics",
    "BB.06.k.03.a": "A party",
    "BB.06.k.03.b": "Groups/attitudes right to left",
    "BB.06.k.04": "Political philosophy",
    "BB.06.k.04.a": "Socialism",
    "BB.06.k.04.b": "Communism",
    "BB.06.k.04.c": "Fascism",
    "BB.06.k.04.d": "Nazism",
    "BB.06.k.04.e": "Principles of/attachment to types of government",
    "BB.06.k.05": "British politics",
    "BB.06.k.05.a": "British party politics",
    "BB.06.k.06": "Irish politics",
    "BB.06.k.07": "American politics",
    "BB.06.k.08": "French politics",
    "BB.06.k.09": "German politics",
    "BB.06.k.10": "Italian politics",
    "BB.06.k.11": "Spanish politics",
    "BB.06.k.12": "Russian politics",
    "BB.06.k.13": "Politics in India and Far East",
    "BB.06.k.14": "Arab and Middle East politics",
    "BB.06.k.15": "African politics",
    "BB.06.k.16": "Central and South American politics",
    "BB.06.k.17": "International politics/relations",
    "BB.06.k.17.a": "Diplomacy",
    "BB.06.k.17.b": "International agreements",
    "BB.07": "Office",
    "BB.07.a": "Holder of office",
    "BB.07.a.01": "Official of royal/great household",
    "BB.07.a.02": "High officials of state",
    "BB.07.a.03": "Public officials",
    "BB.07.a.04": "Ceremonial officials",
    "BB.07.a.05": "Magistrate",
    "BB.07.a.06": "Other municipal officials",
    "BB.07.a.07": "Parish official",
    "BB.07.a.08": "Roman magistrates and officials",
    "BB.07.b": "Accession/entering upon office/authority",
    "BB.07.c": "Withdrawing from/vacating office",
    "BB.07.d": "Appointment to office",
    "BB.07.d.01": "Choosing/fact of being chosen for office",
    "BB.07.d.01.a": "Election of representative body by vote",
    "BB.07.e": "Removal from office/authority",
    "BB.07.f": "Symbol of office/authority",
    "BB.08": "Exercise of authority",
    "BB.08.a": "Investing with delegated authority",
    "BB.08.b": "Action/function of a delegate/deputy",
    "BB.08.c": "One having delegated/derived authority",
    "BB.09": "Subjection",
    "BB.09.a": "Subjecting/subjugation",
    "BB.09.b": "Service",
    "BB.09.b.01": "Servant",
    "BB.09.b.01.a": "Personal/domestic servant",
    "BB.09.b.01.b": "Retainer/follower",
    "BB.09.b.02": "Feudal service",
    "BB.09.c": "Slavery/bondage",
    "BB.09.d": "Obedience",
    "BB.09.d.01": "Manageability",
    "BB.09.d.02": "Submissiveness",
    "BB.09.d.02.a": "Submission",
    "BB.09.d.03": "Compulsion",
    "BB.09.e": "Restraint/restraining",
    "BB.09.e.01": "Restraint depriving of liberty",
    "BB.09.e.01.a": "Confinement",
    "BB.09.e.01.b": "Binding/fettering",
    "BB.09.e.02": "Restriction/limitation",
    "BB.09.f": "Prohibition",
    "BB.10": "Lack of subjection",
    "BB.10.a": "Unruliness",
    "BB.10.a.01": "Disorder/riot",
    "BB.10.a.02": "Political unrest",
    "BB.10.b": "Rebelliousness",
    "BB.10.b.01": "Political disaffection",
    "BB.10.b.02": "Militancy",
    "BB.10.b.02.a": "Terrorism",
    "BB.10.b.03": "Mutiny",
    "BB.10.b.04": "Insurrection",
    "BB.10.b.05": "Revolution",
    "BB.10.b.06": "Sedition",
    "BB.10.c": "Freedom/liberty",
    "BB.10.c.01": "Independence",
    "BB.10.c.02": "Freedom of action/from restraint",
    "BB.10.c.03": "Liberation",
    "BB.10.d": "Permission",
    "BB.11": "Lack of power/authority",
    "BB.12": "Punishment",
    "BB.12.a": "Retributive punishment",
    "BB.12.b": "Corporal punishment",
    "BB.12.b.01": "Instrument/place of corporal punishment",
    "BB.12.c": "Capital punishment",
    "BB.12.c.01": "Hanging",
    "BB.12.d": "Torture",
    "BB.12.d.01": "Instrument/place of torture",
    "BB.12.e": "Imprisonment",
    "BB.12.e.01": "Prison",
    "BB.12.e.02": "Prisoner",
    "BB.12.f": "Outlawry",
    "BB.12.g": "Public/popular punishments",
    "BB.12.h": "Fine",
    "BC": "Law",
    "BC.01": "Written laws",
    "BC.02": "Legislation",
    "BC.02.a": "Legislator",
    "BC.03": "Jurisprudence",
    "BC.04": "Study of law",
    "BC.05": "Legal profession",
    "BC.05.a": "Lawyer",
    "BC.05.b": "Lawyer's client",
    "BC.06": "Rule of law",
    "BC.06.a": "Illegality",
    "BC.06.b": "Lawlessness",
    "BC.07": "Law enforcement",
    "BC.07.a": "Police force/the police",
    "BC.07.a.01": "Political police",
    "BC.07.b": "Law-enforcement/peace-officer",
    "BC.07.c": "Investigation of crime",
    "BC.08": "Legal power",
    "BC.09": "Administration of justice",
    "BC.09.a": "Judicial body/assembly/court",
    "BC.09.a.01": "A/the session of a court",
    "BC.09.a.02": "Place where court is held",
    "BC.09.b": "One who administers justice",
    "BC.09.b.01": "Judge",
    "BC.09.b.02": "Jury",
    "BC.09.b.03": "An officer of the court",
    "BC.09.c": "Court papers",
    "BC.09.d": "Process/writ/warrant/order",
    "BC.09.e": "General proceedings",
    "BC.09.e.01": "Legal seizure/recovery of property",
    "BC.09.e.02": "Arrest",
    "BC.09.e.03": "Accusation/allegation/indictment",
    "BC.09.e.04": "Bailing/bail",
    "BC.09.f": "Court proceedings/procedure",
    "BC.09.f.01": "Action of courts in claims/grievances",
    "BC.09.f.02": "Pleading",
    "BC.09.f.03": "Evidence",
    "BC.09.f.04": "Trying/hearing of cause",
    "BC.09.f.05": "Judging",
    "BC.10": "Legal capacity",
    "BC.11": "Legal concepts",
    "BC.12": "Legal right",
    "BC.12.a": "Right of specific class/person/place",
    "BC.12.b": "Right of possession/ownership",
    "BC.12.b.01": "Tenure of property",
    "BC.12.b.02": "Eviction from property",
    "BC.12.b.03": "Right to succeed to title/position/estate",
    "BC.12.b.04": "Succession",
    "BC.12.c": "Rights to do/use something",
    "BC.12.d": "Withdrawal/loss of legal rights",
    "BC.12.e": "Resumption/restoration of rights",
    "BC.13": "Legal obligation",
    "BC.13.a": "Bond/recognizance",
    "BC.13.b": "Contract",
    "BC.14": "Legal possession",
    "BC.15": "Transfer of property",
    "BC.15.a": "Charter/deed conveying property",
    "BC.15.b": "Last will and testament",
    "BC.15.c": "Settlement of property",
    "BC.16": "Legal document",
    "BD": "Morality",
    "BD.01": "Duty/obligation",
    "BD.01.a": "Responsibility",
    "BD.01.b": "Moral or legal constraint",
    "BD.01.b.01": "Immunity/exemption from liability",
    "BD.01.b.01.a": "Excuse",
    "BD.01.b.01.b": "Justification",
    "BD.01.b.01.c": "Forgiveness",
    "BD.01.b.01.d": "Impunity",
    "BD.01.c": "Recognition of duty",
    "BD.01.c.01": "Faithfulness/trustworthiness",
    "BD.01.c.01.a": "Fidelity/loyalty",
    "BD.01.c.02": "Undutifulness",
    "BD.01.c.02.a": "Unfaithfulness",
    "BD.01.c.02.b": "Disloyalty",
    "BD.01.c.02.c": "Treachery",
    "BD.01.c.02.d": "Betrayal",
    "BD.02": "Dueness/propriety",
    "BD.02.a": "Impropriety/quality of being morally unfitting",
    "BD.03": "Rightness/justice",
    "BD.03.a": "Wrong/injustice",
    "BD.04": "Virtue",
    "BD.04.a": "Morally elevated quality",
    "BD.04.a.01": "Unselfishness",
    "BD.04.b": "Absence of moral flaw",
    "BD.04.c": "Righteousness/rectitude",
    "BD.04.c.01": "Reform/amendment/correction",
    "BD.04.c.01.a": "Repentance/contrition",
    "BD.04.c.01.b": "Atonement",
    "BD.04.d": "Probity/honesty/uprightness",
    "BD.04.d.01": "Honourableness",
    "BD.04.e": "Purity",
    "BD.04.e.01": "Chastity",
    "BD.04.e.01.a": "Modesty/decency",
    "BD.04.e.02": "Innocence",
    "BD.05": "Moral evil",
    "BD.05.a": "Moral/spiritual degeneration/degeneracy",
    "BD.05.a.01": "Degrading/impairing morally",
    "BD.05.b": "Evil nature/character",
    "BD.05.b.01": "Lack of magnanimity/noble-mindedness",
    "BD.05.b.01.a": "Self-interest",
    "BD.05.c": "Wrong conduct",
    "BD.05.c.01": "Evil-doing/wrong-doing",
    "BD.05.d": "Wickedness",
    "BD.05.d.01": "Roguery/knavery/rascalry",
    "BD.05.e": "Lack of principle/integrity",
    "BD.05.f": "Guilt",
    "BD.05.g": "Licentiousness",
    "BD.05.g.01": "Profligacy/dissoluteness/debauchery",
    "BD.05.g.02": "Unchastity",
    "BD.05.g.02.a": "Lasciviousness/lust",
    "BD.05.g.02.b": "Loss of chastity",
    "BD.05.g.02.c": "Fornication/adultery/incest",
    "BD.05.g.02.d": "Prostitution",
    "BD.05.g.03": "Moral/spiritual impurity",
    "BD.05.g.03.a": "Indecency",
    "BE": "Education",
    "BE.01": "Upbringing",
    "BE.02": "Teaching",
    "BE.02.a": "Systematic/formal teaching",
    "BE.02.b": "Training",
    "BE.02.c": "Instilling ideas",
    "BE.02.d": "Means of teaching",
    "BE.02.e": "Teacher",
    "BE.02.e.01": "School-teacher/schoolmaster",
    "BE.02.e.02": "University/college teacher",
    "BE.03": "Learning",
    "BE.03.a": "Study",
    "BE.03.a.01": "Subject/object of study",
    "BE.03.b": "Learner",
    "BE.03.b.01": "Qualities of learners",
    "BE.03.b.02": "One attending school",
    "BE.03.b.03": "College/university student",
    "BE.04": "Member of university",
    "BE.05": "Educational administration",
    "BE.05.a": "School administration",
    "BE.05.b": "University administration",
    "BE.05.b.01": "Taking degree/graduation",
    "BE.05.c": "Examination",
    "BE.06": "Place of education",
    "BE.06.a": "School",
    "BE.06.b": "College/university",
    "BE.06.c": "Educational buildings",
    "BF": "Faith",
    "BF.01": "Creed",
    "BF.02": "Doctrine",
    "BF.03": "Religion",
    "BF.03.a": "A religion/church",
    "BF.04": "Theism",
    "BF.04.a": "Belief in God",
    "BF.04.b": "Paganism",
    "BF.04.c": "Atheism",
    "BF.05": "Orthodoxy",
    "BF.06": "Heterodoxy",
    "BF.07": "Free-thought",
    "BF.08": "Superstition",
    "BF.09": "Heresy",
    "BF.09.a": "Search for heresy",
    "BF.10": "Conformity",
    "BF.11": "Nonconformity",
    "BF.11.a": "Recusancy",
    "BF.12": "Apostasy",
    "BF.13": "Sectarianism",
    "BF.13.a": "Bigotry",
    "BF.13.b": "Schism",
    "BF.14": "Catholicity",
    "BF.15": "Bible, scripture",
    "BF.15.a": "Text",
    "BF.15.b": "Old/new testament",
    "BF.15.b.01": "Old Testament",
    "BF.15.b.02": "Apocrypha",
    "BF.15.b.03": "New Testament",
    "BF.15.c": "Biblical personages",
    "BF.15.c.01": "Apostle",
    "BF.15.c.02": "Disciple",
    "BF.15.d": "Biblical events",
    "BF.15.d.01": "Second coming",
    "BF.15.e": "Hebrew scripture",
    "BF.15.f": "Non-Judaeo-Christian Scriptures",
    "BF.16": "Patristics, Church Fathers",
    "BF.17": "Religious law(s)",
    "BF.17.a": "Canon Law",
    "BF.17.b": "Jewish Law",
    "BF.17.b.01": "Talmudic scholar, rabbi",
    "BF.17.c": "Islamic Law",
    "BF.18": "Theology",
    "BF.18.a": "Theologian",
    "BF.18.b": "Systems of theology",
    "BF.18.c": "Branches of theology",
    "BF.19": "Holiness",
    "BF.19.a": "Saint",
    "BF.19.a.01": "Canonization",
    "BF.19.a.02": "Discanonization",
    "BF.19.b": "Consecration",
    "BF.19.b.01": "Blessing",
    "BF.19.c": "Unholiness",
    "BF.20": "Piety",
    "BF.20.a": "Asceticism/mortification",
    "BF.20.b": "Sanctimoniousness",
    "BF.20.c": "Impiety",
    "BF.21": "Spirituality",
    "BF.21.a": "Soul",
    "BF.21.a.01": "Transmigration, reincarnation",
    "BF.21.a.02": "Regeneration",
    "BF.21.a.03": "Doctrines concerning the soul",
    "BF.21.b": "Unspirituality",
    "BF.21.c": "Contemplation, self-examination",
    "BF.21.d": "Rapture",
    "BF.21.e": "Mysticism",
    "BF.21.e.01": "A mystery",
    "BF.21.f": "Divine inspiration/revelation",
    "BF.21.f.01": "Prophecy, vision",
    "BF.21.g": "Grace",
    "BF.21.g.01": "Righteousness",
    "BF.21.h": "Sin",
    "BF.21.h.01": "Contrition",
    "BF.21.h.02": "Atonement",
    "BF.21.i": "Salvation, redemption",
    "BF.21.j": "Reprobation",
    "BF.22": "Sect",
    "BF.22.a": "Judaism",
    "BF.22.a.01": "Gentile",
    "BF.22.b": "Christianity",
    "BF.22.b.01": "Person",
    "BF.22.b.02": "Conversion to Christianity",
    "BF.22.b.03": "Lack of Christianity",
    "BF.22.b.04": "Opposition to Christianity",
    "BF.22.b.05": "Major early Christian sects",
    "BF.22.b.06": "Greek orthodoxy",
    "BF.22.b.07": "Roman Catholicism",
    "BF.22.b.07.a": "Conversion to Catholicism",
    "BF.22.b.07.b": "Anti-catholic",
    "BF.22.b.08": "Protestantism",
    "BF.22.b.08.a": "Conversion to Protestantism",
    "BF.22.b.08.b": "Reformation",
    "BF.22.b.08.c": "Anglicanism",
    "BF.22.b.08.d": "Baptists",
    "BF.22.b.08.e": "Calvinism",
    "BF.22.b.08.f": "Lutheranism",
    "BF.22.b.08.g": "Methodism",
    "BF.22.b.08.h": "Mormonism",
    "BF.22.b.08.i": "Presbyterianism",
    "BF.22.b.08.j": "Puritanism",
    "BF.22.b.08.k": "Quakerism",
    "BF.22.b.08.l": "Unitarianism",
    "BF.22.c": "Non-Judaeo-Christian religions",
    "BF.22.c.01": "Buddhism",
    "BF.22.c.02": "Confucianism",
    "BF.22.c.03": "Hinduism",
    "BF.22.c.04": "Islam",
    "BF.23": "Church government",
    "BF.23.a": "Ecclesiastical authority",
    "BF.23.b": "Ecclesiastical discipline",
    "BF.23.b.01": "Papal court (Curia)",
    "BF.23.b.02": "Papal court (Inquisition)",
    "BF.23.c": "Council",
    "BF.23.c.01": "Chapter",
    "BF.23.c.01.a": "Member of chapter",
    "BF.23.d": "Clergyman",
    "BF.23.d.01": "Pope",
    "BF.23.d.01.a": "Antipope",
    "BF.23.d.01.b": "Offices/officials",
    "BF.23.d.01.c": "Papal documents",
    "BF.23.d.02": "Cardinal",
    "BF.23.d.03": "Archbishop",
    "BF.23.d.04": "Bishop",
    "BF.23.d.05": "Priest",
    "BF.23.d.06": "Rector",
    "BF.23.d.07": "Parson",
    "BF.23.d.08": "Pastor",
    "BF.23.d.09": "Vicar",
    "BF.23.d.10": "Chaplain",
    "BF.23.d.11": "Preacher",
    "BF.23.d.12": "Acolyte",
    "BF.23.e": "Religious",
    "BF.23.e.01": "Religious superior",
    "BF.23.e.02": "Monk",
    "BF.23.e.03": "Nun",
    "BF.23.e.04": "Friar",
    "BF.23.e.05": "Religious order",
    "BF.23.e.05.a": "Religio-military religious",
    "BF.23.f": "Laity",
    "BF.23.f.01": "Congregation",
    "BF.23.f.02": "Lay functionaries",
    "BF.24": "Worship",
    "BF.24.a": "Kinds of worship",
    "BF.24.b": "Observance, ritual",
    "BF.24.b.01": "Meeting for observance",
    "BF.24.b.02": "Rule, rubric",
    "BF.24.c": "Parts of service",
    "BF.24.c.01": "Homily",
    "BF.24.c.02": "Canon",
    "BF.24.d": "Church music",
    "BF.24.d.01": "Hymn",
    "BF.24.d.01.a": "Anthem",
    "BF.24.d.02": "Psalm",
    "BF.24.e": "Liturgical year (chronological order)",
    "BF.24.e.01": "Sabbath",
    "BF.24.e.02": "Feast, festival",
    "BF.24.e.02.a": "Advent",
    "BF.24.e.02.b": "Christmas",
    "BF.24.e.02.c": "Lent",
    "BF.24.e.02.d": "Holy Week",
    "BF.24.e.02.e": "Jewish seasons and feasts",
    "BF.24.e.03": "Fast",
    "BF.24.f": "Canonical hours",
    "BF.24.g": "Church-going",
    "BF.24.h": "Sacrament",
    "BF.24.h.01": "Baptism",
    "BF.24.h.02": "Confession",
    "BF.24.h.03": "Communion",
    "BF.24.h.04": "Order",
    "BF.24.h.04.a": "Ordination",
    "BF.24.h.05": "(Extreme) Unction",
    "BF.24.i": "Prayer",
    "BF.24.j": "Good works",
    "BF.24.k": "Preaching",
    "BF.24.k.01": "Evangelization",
    "BF.24.k.02": "Mission",
    "BF.24.k.03": "Conversion",
    "BF.24.l": "Pilgrimage",
    "BF.24.m": "Crusade",
    "BF.24.n": "Sacrifice/a sacrifice",
    "BF.24.o": "Cleanness (ceremonial)",
    "BF.24.p": "Sacrilege",
    "BF.24.p.01": "Blasphemy",
    "BF.24.q": "Vow",
    "BF.24.r": "Martyrdom",
    "BF.24.s": "Exorcism",
    "BF.24.t": "Excommunication",
    "BF.24.u": "Benefice",
    "BF.25": "Artefacts",
    "BF.25.a": "Property",
    "BF.25.b": "Sanctuary/holy place",
    "BF.25.b.01": "Temple",
    "BF.25.b.02": "Church/place of worship",
    "BF.25.b.03": "Shrine",
    "BF.25.c": "Division of religious building (general)",
    "BF.25.c.01": "Altar",
    "BF.25.c.02": "Tower/steeple",
    "BF.25.c.03": "Chapel",
    "BF.25.d": "Monastic property (general)",
    "BF.25.d.01": "Monastery/convent",
    "BF.25.e": "Clerical residence (general)",
    "BF.25.f": "Furniture",
    "BF.25.f.01": "Lectern/pulpit",
    "BF.25.f.02": "Seat",
    "BF.25.g": "Implement (general)",
    "BF.25.g.01": "Rosary",
    "BF.25.g.02": "Vessel (general)",
    "BF.25.h": "Cloths, carpets, cushions",
    "BF.25.i": "Portable shrines/relics",
    "BF.25.i.01": "Relic",
    "BF.25.j": "Vestments",
    "BF.25.k": "Monastic garb",
    "BF.25.l": "Lay garments",
    "BF.25.m": "Consumables",
    "BF.25.m.01": "Eucharistic elements",
    "BF.25.n": "Book (general)",
    "BF.25.o": "Symbol (general)",
    "BF.25.o.01": "Christian symbols/images",
    "BG": "Communication",
    "BG.01": "Expression",
    "BG.02": "Manifestation",
    "BG.02.a": "Openness/unconcealedness",
    "BG.02.b": "Disclosure/revelation",
    "BG.02.c": "Offering for inspection/consideration",
    "BG.02.d": "Showing to the sight",
    "BG.02.d.01": "Exposure to public view",
    "BG.02.d.01.a": "An exhibition",
    "BG.03": "Representation",
    "BG.03.a": "Physical representation of abstraction",
    "BG.03.a.01": "Symbolizing",
    "BG.03.a.02": "Personification",
    "BG.03.b": "Role-playing",
    "BG.03.c": "A plastic/graphic representation",
    "BG.03.c.01": "Drawing plans/diagrams",
    "BG.03.c.02": "Drawing lines",
    "BG.03.d": "Three-dimensional representation",
    "BG.04": "Indication",
    "BG.04.a": "Designation",
    "BG.04.b": "That which identifies/distinguishes",
    "BG.04.b.01": "Personal identification",
    "BG.04.b.01.a": "Signature",
    "BG.04.b.02": "Identifying word/cry",
    "BG.04.b.03": "Identificatory labelling",
    "BG.04.b.04": "Sign-board",
    "BG.04.c": "Marking",
    "BG.04.c.01": "A mark",
    "BG.04.c.01.a": "Trace/vestige",
    "BG.04.c.02": "Marking out",
    "BG.04.c.03": "Marking to identify",
    "BG.04.c.03.a": "Mark of identification",
    "BG.04.c.04": "Mark of quality",
    "BG.04.c.05": "Imprinting",
    "BG.04.c.05.a": "Sealing",
    "BG.04.d": "Pointing out",
    "BG.04.e": "Signalling",
    "BG.04.e.01": "Visual signalling",
    "BG.04.e.02": "Audible signalling",
    "BG.04.f": "Gesturing/gesture",
    "BG.04.f.01": "Derisive gesture",
    "BG.04.f.02": "Hand gesture",
    "BG.04.g": "Insignia",
    "BG.04.g.01": "Heraldic devices collectively",
    "BG.04.g.01.a": "Heraldry",
    "BG.04.g.02": "Standard",
    "BG.05": "Information",
    "BG.05.a": "Action of informing",
    "BG.05.b": "Enlightenment",
    "BG.05.c": "Informing on/against",
    "BG.05.d": "Reporting",
    "BG.05.e": "Intimation/making known",
    "BG.05.f": "Announcing/proclaiming",
    "BG.05.g": "Publishing/ spreading abroad",
    "BG.05.g.01": "Publishing/spreading by leaflets/notices",
    "BG.05.g.02": "Advertising",
    "BG.05.g.02.a": "Business of advertising",
    "BG.05.h": "Message",
    "BG.05.i": "News/tidings",
    "BG.05.j": "Rumour",
    "BG.05.k": "Hint/covert suggestion",
    "BG.06": "Record",
    "BG.06.a": "Written record",
    "BG.06.a.01": "Register/record-book",
    "BG.06.a.02": "Daily record/journal",
    "BG.06.a.03": "Album/commonplace-book",
    "BG.06.a.04": "Historical record/chronicle",
    "BG.06.a.05": "Compiler/keeper of written records",
    "BG.06.a.06": "Arrangement and storage of written records",
    "BG.06.b": "List",
    "BG.06.c": "Pictorial, etc. records",
    "BG.06.d": "Memorial/monument",
    "BG.06.d.01": "Medal",
    "BG.06.e": "Recording/reproducing sound/visual material",
    "BG.06.e.01": "Sound recording and reproduction",
    "BG.06.e.01.a": "A sound recording",
    "BG.06.e.01.b": "Sound recording/reproducing equipment",
    "BG.06.e.02": "Production/use of video recording",
    "BG.07": "Writing",
    "BG.07.a": "State of having been written",
    "BG.07.b": "Manner of writing",
    "BG.07.b.01": "Copying/transcribing",
    "BG.07.c": "System of writing",
    "BG.07.c.01": "Shorthand",
    "BG.07.c.02": "Alphabet",
    "BG.07.d": "Written character",
    "BG.07.d.01": "Punctuation",
    "BG.07.e": "Handwriting/style of",
    "BG.07.e.01": "Formation of letters",
    "BG.07.f": "Written text",
    "BG.07.f.01": "An inscription",
    "BG.07.f.02": "Layout",
    "BG.07.f.03": "Decoration",
    "BG.07.g": "Writer",
    "BG.07.h": "Writing materials",
    "BG.07.h.01": "Material to write on",
    "BG.07.h.01.a": "Paper",
    "BG.07.h.01.b": "Skin (vellum/parchment)",
    "BG.07.h.02": "Writing instrument",
    "BG.07.h.03": "Ink",
    "BG.07.i": "Study/science of written symbols",
    "BG.07.j": "Spelling",
    "BG.08": "Printing",
    "BG.08.a": "Manner/style of printing",
    "BG.08.b": "Preparatory processes",
    "BG.08.c": "Post-printing processes",
    "BG.08.d": "Correction",
    "BG.08.e": "Material to be printed",
    "BG.08.f": "Printed matter",
    "BG.08.f.01": "Arrangement/appearance of printed matter",
    "BG.08.f.02": "Printed character(s)",
    "BG.08.g": "Printer",
    "BG.08.h": "Printing trade",
    "BG.08.i": "Printing machine/press",
    "BG.08.j": "Types/blocks/plates",
    "BG.08.j.01": "Type",
    "BG.08.k": "Paper",
    "BG.08.l": "Typing",
    "BG.08.l.01": "Typist",
    "BG.08.l.02": "Typewriter",
    "BG.08.m": "Publishing",
    "BG.08.m.01": "A publication",
    "BG.08.m.02": "Publisher",
    "BG.08.m.03": "Editing for publication",
    "BG.09": "Reading",
    "BG.09.a": "Reader",
    "BG.10": "Book",
    "BG.10.a": "Manuscript book",
    "BG.10.b": "Text-book/book of instructions",
    "BG.10.c": "Reference book",
    "BG.10.d": "Parts of book",
    "BG.10.e": "Leaves/pages of book",
    "BG.10.f": "Matter of book",
    "BG.10.g": "Library/collection of books",
    "BG.10.h": "Receptacle for books",
    "BG.10.i": "Manufacture/production of books",
    "BG.10.j": "Illustration of books",
    "BG.11": "Journalism",
    "BG.11.a": "Editing",
    "BG.11.b": "Appearance in the press",
    "BG.11.c": "Supply of news/newspapers",
    "BG.11.d": "Journalist",
    "BG.11.e": "Journal",
    "BG.11.e.01": "Newspaper",
    "BG.11.e.02": "Periodical",
    "BG.11.e.03": "Matter of/for journals",
    "BG.11.e.04": "Parts and layout of journals",
    "BG.12": "Broadcasting",
    "BG.12.a": "Broadcasting service",
    "BG.12.b": "A broadcast programme/item",
    "BG.12.c": "Broadcaster",
    "BG.12.d": "Audience",
    "BG.12.e": "Putting on/producing broadcast",
    "BG.12.f": "Equipment",
    "BG.12.g": "Radio broadcasting",
    "BG.12.h": "Television",
    "BG.12.h.01": "Production of television broadcast",
    "BG.12.h.02": "Visual element",
    "BG.12.h.03": "Transmitting/receiving apparatus",
    "BG.13": "Correspondence",
    "BG.13.a": "Letter-writing",
    "BG.13.b": "Sending items",
    "BG.13.c": "Letter",
    "BG.13.c.01": "Mail",
    "BG.13.d": "Postal services",
    "BG.13.d.01": "Payment for postage",
    "BG.13.d.02": "Person/vehicle that carries letters/mail",
    "BG.13.d.03": "Equipment for sending/delivering mail",
    "BG.14": "Telecommunication",
    "BG.14.a": "Radio communications",
    "BG.14.a.01": "Radio equipment",
    "BG.14.b": "Telegraphy/telephony",
    "BG.14.b.01": "Telegraphy",
    "BG.14.b.02": "Telephony",
    "BG.14.c": "Transmission of computerized information",
    "BH": "Travel and travelling",
    "BH.01": "A journey",
    "BH.01.a": "Record/account of journey(s)",
    "BH.02": "Traveller",
    "BH.03": "Travel in specific course/direction",
    "BH.04": "Travel from place to place",
    "BH.05": "Departure/leaving/going away",
    "BH.06": "Arrival",
    "BH.07": "Return",
    "BH.08": "Guidance in travel",
    "BH.09": "Authorization to travel to/from/in a country",
    "BH.10": "Going on foot",
    "BH.11": "Transport",
    "BH.11.a": "Transport/conveyance by carrying",
    "BH.11.b": "Transport/conveyance by drawing along",
    "BH.11.c": "Riding on horse (or other animal)",
    "BH.11.c.01": "Rider",
    "BH.11.d": "Cycling",
    "BH.11.e": "Motor-cycling",
    "BH.11.f": "Transport/conveyance in a vehicle",
    "BH.11.f.01": "Transport of goods in a vehicle",
    "BH.11.f.02": "Riding in a vehicle",
    "BH.11.f.03": "Driving/operating a vehicle",
    "BH.11.f.03.a": "Driver/operator of vehicle",
    "BH.11.f.04": "Transport by vehicles plying for hire",
    "BH.11.f.05": "Public passenger transport",
    "BH.11.f.06": "Movement of vehicles",
    "BH.11.f.07": "Vehicular traffic",
    "BH.11.g": "Transport by psychic/futuristic means",
    "BH.12": "Means of travel",
    "BH.12.a": "Route/way",
    "BH.12.a.01": "Way/passage/means of access to a place",
    "BH.12.a.02": "Way/path/track",
    "BH.12.a.02.a": "Junction of roads/paths/tracks",
    "BH.12.a.02.b": "Track/trail/path",
    "BH.12.a.02.c": "Path/place for walking",
    "BH.12.a.02.d": "Road",
    "BH.12.a.02.e": "Street",
    "BH.12.a.02.f": "Lane",
    "BH.12.a.02.g": "Road laid with parallel planks/slabs/rails",
    "BH.12.b": "A conveyance",
    "BH.12.b.01": "Conveyance carried by man/beast",
    "BH.12.b.02": "Vehicle",
    "BH.12.b.02.a": "Vehicle moving on runners",
    "BH.12.b.02.b": "Vehicle moving on wheels",
    "BH.12.b.02.c": "Vehicle pushed/pulled by person",
    "BH.12.b.02.d": "Vehicle propelled by feet",
    "BH.12.b.02.e": "Cart/carriage/wagon",
    "BH.12.b.02.f": "Powered vehicle generally",
    "BH.12.b.02.g": "Motor car",
    "BH.12.b.02.h": "Motor lorry/truck/van",
    "BH.12.b.02.i": "Testing, servicing, and storage of motor vehicles",
    "BH.12.b.02.j": "Motor-cycle",
    "BH.12.b.02.k": "Vehicles (plying) for hire",
    "BH.12.b.02.l": "Public service vehicle",
    "BH.12.b.02.m": "Military vehicles",
    "BH.13": "Rail travel",
    "BH.13.a": "Railway worker",
    "BH.13.b": "Railway system/organization",
    "BH.13.c": "Rolling stock",
    "BH.14": "Navigation",
    "BH.14.a": "Transportation by water",
    "BH.14.b": "Seafaring life",
    "BH.14.c": "Directing/managing a ship",
    "BH.14.c.01": "Steering",
    "BH.14.c.02": "Use of wind",
    "BH.14.c.03": "Use of sails/spars/rigging",
    "BH.14.d": "Propelling boat by oars/paddle/pole",
    "BH.14.e": "Berthing/mooring/anchoring",
    "BH.14.e.01": "Harbour/port",
    "BH.14.f": "Launching a vessel",
    "BH.14.g": "Grounding of vessel",
    "BH.14.h": "Action/motion of vessel",
    "BH.14.i": "Shipwreck",
    "BH.14.j": "One who travels by water/sea",
    "BH.14.j.01": "Sailor",
    "BH.14.k": "Vessel/ship/boat",
    "BH.14.k.01": "Vessels of primitive construction",
    "BH.14.k.02": "Flat-bottomed boat",
    "BH.14.k.03": "Vessels propelled by oars/poles",
    "BH.14.k.04": "Vessel propelled by sail",
    "BH.14.k.05": "Mechanically propelled vessels",
    "BH.14.k.06": "War vessel",
    "BH.14.k.07": "Privateer/pirate ship",
    "BH.14.k.08": "Trading vessel",
    "BH.14.k.08.a": "Cargo vessel",
    "BH.14.k.09": "Vessel for transporting people or goods",
    "BH.14.k.09.a": "Passenger vessel",
    "BH.14.k.10": "Fishing vessel",
    "BH.14.k.11": "Boat assisting larger vessel",
    "BH.14.k.12": "Pleasure vessel",
    "BH.14.k.13": "Parts of vessels",
    "BH.14.k.13.a": "Body of vessel",
    "BH.14.k.13.b": "Room/locker/quarters",
    "BH.14.k.14": "Equipment of vessel",
    "BH.14.k.14.a": "Masts/rigging/sails",
    "BH.14.k.14.b": "Rowing apparatus",
    "BH.14.k.14.c": "Propulsion machinery",
    "BH.14.k.14.d": "Steering equipment",
    "BH.14.k.14.e": "Anchoring equipment",
    "BH.14.k.15": "Ship's papers",
    "BH.14.k.16": "Buoys/marks/lighthouses",
    "BH.14.k.17": "Shipbuilding and repairing",
    "BH.14.k.17.a": "Boat-builder/shipbuilder",
    "BH.14.k.17.b": "Shipyard/boat-yard",
    "BH.15": "Air/space travel",
    "BH.15.a": "Action of flying (in) aircraft",
    "BH.15.a.01": "Navigation of course of aircraft",
    "BH.15.b": "Aerodynamic forces and concepts",
    "BH.15.c": "Transport by air",
    "BH.15.d": "Regulation and control of flying",
    "BH.15.e": "Airfield/airport",
    "BH.15.f": "Gliding and hang-gliding",
    "BH.15.g": "Ballooning",
    "BH.15.h": "Parachuting",
    "BH.15.i": "Use/science of rockets",
    "BH.15.j": "Space flight",
    "BH.15.k": "People who fly in aircraft/spacecraft",
    "BH.15.l": "A means of conveyance through the air",
    "BH.15.l.01": "Aeroplane",
    "BH.15.l.01.a": "Controls and instruments",
    "BH.15.l.01.b": "Means of propulsion",
    "BH.15.l.02": "Glider",
    "BH.15.l.03": "Rotary wing aircraft",
    "BH.15.l.04": "Balloons and airships",
    "BH.15.l.05": "Parachute",
    "BH.15.l.06": "Spacecraft",
    "BH.15.l.06.a": "Rocket",
    "BH.15.l.07": "Construction and servicing aircraft/spacecraft",
    "BI": "Occupation and work",
    "BI.01": "Work",
    "BI.01.a": "Times/periods of work",
    "BI.01.b": "Amounts of work",
    "BI.01.c": "Product of work",
    "BI.02": "Position/job",
    "BI.03": "Duties",
    "BI.04": "Working",
    "BI.04.a": "Career",
    "BI.04.b": "Labour supply",
    "BI.04.c": "Labour relations",
    "BI.04.d": "Association of employers/employees",
    "BI.05": "Business affairs",
    "BI.05.a": "Doctrines/methods/management systems",
    "BI.05.b": "A business/company",
    "BI.06": "Industry",
    "BI.06.a": "Manufacture/production",
    "BI.06.b": "General/industrial manufacturing processes",
    "BI.06.b.01": "Mending/repairing",
    "BI.06.c": "Working with specific materials",
    "BI.06.c.01": "Working with metal",
    "BI.06.d": "Building/constructing",
    "BI.06.d.01": "That which is built/constructed",
    "BI.06.d.02": "Building/constructing with stone",
    "BI.06.d.03": "Building/constructing with brick",
    "BI.06.d.04": "Constructing/working with wood",
    "BI.06.d.05": "Surfacing/cladding",
    "BI.06.d.06": "Paving and road-building",
    "BI.06.d.07": "Making/working railroads",
    "BI.06.e": "Decorating and painting",
    "BI.06.f": "Plumbing, conducting of water, etc. by channels/pipes",
    "BI.06.g": "Engineering",
    "BI.06.h": "Earth-moving, etc.",
    "BI.06.i": "Quarrying",
    "BI.06.j": "Mining",
    "BI.06.k": "Drilling for oil/gas",
    "BI.06.l": "Diving/dredging",
    "BI.06.m": "Working with tools/equipment",
    "BI.06.m.01": "Fastening",
    "BI.07": "Study of work",
    "BI.08": "Lack of work",
    "BI.09": "Worker",
    "BI.09.a": "Workers in command of others",
    "BI.09.b": "Non-manual worker",
    "BI.09.b.01": "Businessman",
    "BI.09.c": "Manual/industrial worker",
    "BI.09.c.01": "Potter",
    "BI.09.c.02": "Glass-maker",
    "BI.09.c.03": "Maker of furniture/furnishings",
    "BI.09.c.04": "Metalworker",
    "BI.09.c.05": "Worker with stone",
    "BI.09.c.06": "Woodworker",
    "BI.09.c.07": "Builder",
    "BI.09.c.08": "Decorator",
    "BI.09.c.09": "Utility service workers",
    "BI.09.c.10": "Miner",
    "BI.09.c.11": "Worker in oil industry",
    "BI.09.c.12": "Divers/dredgers",
    "BI.09.c.13": "Engineer",
    "BI.09.d": "Those involved in labour relations/associations",
    "BI.09.e": "Employer",
    "BI.09.f": "One who does not work",
    "BI.10": "Workplace",
    "BI.10.a": "Office",
    "BI.10.b": "Factory",
    "BI.10.c": "Workshop",
    "BI.10.d": "Place for working with wood",
    "BI.10.e": "Place for working with metal",
    "BI.10.f": "Place for working with oil/gas",
    "BI.10.g": "Places where raw materials are extracted",
    "BI.10.g.01": "Quarry",
    "BI.10.g.02": "Mine",
    "BI.10.g.03": "Oil rig",
    "BI.11": "Equipment",
    "BI.11.a": "Tool",
    "BI.11.a.01": "Prehistoric tool",
    "BI.11.b": "Shaping tools/equipment; file, plane",
    "BI.11.c": "Cutting tool",
    "BI.11.c.01": "Knife",
    "BI.11.c.02": "Axe",
    "BI.11.c.03": "Chisel",
    "BI.11.c.04": "Saw",
    "BI.11.c.05": "Shears/scissors",
    "BI.11.d": "Piercing/boring tools",
    "BI.11.e": "Machine-tool",
    "BI.11.e.01": "Lathe",
    "BI.11.f": "Driving/beating tools",
    "BI.11.g": "Screwdrivers, wrenches, spanners",
    "BI.11.h": "Clutching/gripping equipment",
    "BI.11.i": "Digging/lifting tools",
    "BI.11.j": "Lifting/hoisting equipment",
    "BI.11.k": "Ladder",
    "BI.11.k.01": "Scaffolding",
    "BI.11.l": "Pump",
    "BI.11.m": "Mills",
    "BI.11.n": "Furnace/kiln",
    "BI.11.o": "Still",
    "BI.11.p": "Equipment for treating ores",
    "BI.11.q": "Metal-working equipment",
    "BI.11.r": "Building and constructing equipment",
    "BI.11.r.01": "Fastenings",
    "BI.11.s": "Decorating equipment",
    "BI.11.t": "Earth-moving and excavating equipment",
    "BI.11.u": "Mining equipment",
    "BI.11.v": "Oil and natural gas recovery equipment",
    "BI.11.w": "Work-benches, seats, etc.",
    "BI.11.x": "Receptacle/container for work",
    "BI.11.x.01": "Bag",
    "BI.11.x.02": "Basket",
    "BI.11.x.03": "Box",
    "BI.11.x.04": "Vessel",
    "BI.11.x.04.a": "Bucket/pail",
    "BI.11.x.04.b": "Barrel/cask",
    "BI.11.x.04.c": "Flask/flagon/bottle",
    "BI.11.y": "Machine",
    "BI.11.y.01": "Machines which impart power",
    "BI.11.y.01.a": "Motor",
    "BI.11.y.01.b": "Engine",
    "BI.11.y.01.c": "Turbine",
    "BI.11.y.01.d": "Boiler",
    "BI.11.y.02": "Parts of machines",
    "BI.11.y.02.a": "Parts which provide power",
    "BI.11.y.02.b": "Mechanism",
    "BI.11.y.02.c": "Control(s)",
    "BI.11.y.02.d": "Lever",
    "BI.11.y.02.e": "Piston",
    "BI.11.y.02.f": "Wheel",
    "BI.11.y.02.g": "Shaft",
    "BI.12": "Materials",
    "BI.12.a": "Raw material",
    "BI.12.a.01": "Earth",
    "BI.12.a.02": "Clay",
    "BI.12.a.03": "Stone/rock",
    "BI.12.a.04": "Wood",
    "BI.12.a.05": "Plants/grasses/reeds",
    "BI.12.a.06": "Rubber",
    "BI.12.a.07": "Skin/hide",
    "BI.12.a.07.a": "Skin with hair attached/fur",
    "BI.12.a.08": "Bone/horn",
    "BI.12.a.09": "Mineral material",
    "BI.12.a.09.a": "Ore",
    "BI.12.a.09.b": "Mineral and fossil resins",
    "BI.12.a.09.c": "Mineral oil",
    "BI.12.a.10": "Gem/precious/semi-precious stone",
    "BI.12.a.10.a": "Diamond",
    "BI.12.a.10.b": "Rock crystal",
    "BI.12.a.10.c": "Pearl",
    "BI.12.a.10.d": "Artificial stone",
    "BI.12.b": "Derived/manufactured material",
    "BI.12.b.01": "Materials having undergone process",
    "BI.12.b.02": "Clay compositions",
    "BI.12.b.02.a": "Brick",
    "BI.12.b.02.b": "Tile",
    "BI.12.b.02.c": "Pottery/ceramics",
    "BI.12.b.03": "Wood-based materials",
    "BI.12.b.04": "Paper, material for making paper",
    "BI.12.b.04.a": "Materials made from paper/pulp",
    "BI.12.b.05": "Plant fibre materials",
    "BI.12.b.06": "Vegetable extracts/preparations",
    "BI.12.b.07": "Rubber materials",
    "BI.12.b.08": "Leather",
    "BI.12.b.09": "Glass and glass-like materials",
    "BI.12.b.10": "Metal",
    "BI.12.b.10.a": "Qualities of metals",
    "BI.12.b.10.b": "Precious metal",
    "BI.12.b.10.c": "Base metal",
    "BI.12.b.10.d": "Iron",
    "BI.12.b.10.e": "Steel",
    "BI.12.b.10.f": "Alloy",
    "BI.12.b.10.g": "Plated/coated metal",
    "BI.12.b.11": "Materials produced from metal-working",
    "BI.12.b.12": "Extracted/refined oil",
    "BI.12.b.13": "Greasy/fatty material",
    "BI.12.b.14": "Waxy materials",
    "BI.12.b.15": "Processed resinous materials",
    "BI.12.b.16": "Synthetic resins and plastics",
    "BI.12.b.17": "Painting/coating materials",
    "BI.12.b.18": "Adhesive",
    "BI.12.b.19": "Cement/mortar",
    "BI.12.b.20": "Plaster",
    "BI.12.b.21": "Concrete",
    "BI.12.b.22": "Explosive material",
    "BI.12.c": "Fuel",
    "BI.12.c.01": "Wood as fuel",
    "BI.12.c.02": "Coal/types of coal",
    "BI.12.c.03": "Chemical fuel",
    "BI.12.c.04": "Material for igniting",
    "BJ.01": "Trade and finance",
    "BJ.01.a": "Trading organization",
    "BJ.01.b": "Trading conditions",
    "BJ.01.c": "Bargaining",
    "BJ.01.d": "Barter",
    "BJ.01.e": "Brokerage",
    "BJ.01.f": "Illegal/immoral trading",
    "BJ.01.g": "Importing/exporting",
    "BJ.01.h": "Trader",
    "BJ.01.h.01": "Agent/broker",
    "BJ.01.h.02": "Merchant",
    "BJ.01.i": "Buying",
    "BJ.01.i.01": "Buyer",
    "BJ.01.i.02": "Hiring/renting",
    "BJ.01.j": "Selling",
    "BJ.01.j.01": "A public sale",
    "BJ.01.j.02": "Selling/sale of specific things",
    "BJ.01.j.03": "Seller",
    "BJ.01.j.04": "Hiring/letting out",
    "BJ.01.k": "Trading place",
    "BJ.01.k.01": "Market",
    "BJ.01.k.02": "Place of auction",
    "BJ.01.k.03": "Stall/booth",
    "BJ.01.k.04": "Place where retail transactions made",
    "BJ.01.k.05": "A centre of commerce",
    "BJ.01.l": "Merchandise",
    "BJ.01.l.01": "Article(s) to be sold",
    "BJ.01.m": "Money",
    "BJ.01.m.01": "Funds/pecuniary resources",
    "BJ.01.m.02": "Sum of money",
    "BJ.01.m.03": "Value of money",
    "BJ.01.m.04": "Standards and values of currencies",
    "BJ.01.m.05": "Medium of exchange/currency",
    "BJ.01.m.05.a": "Coins collectively",
    "BJ.01.m.05.b": "Promissory notes/bills of exchange, Paper money",
    "BJ.01.m.05.c": "Cheques and drafts",
    "BJ.01.m.06": "Coining",
    "BJ.01.m.07": "Counterfeiting",
    "BJ.01.m.08": "Circulation of money",
    "BJ.01.m.09": "Place for keeping money",
    "BJ.01.m.09.a": "Treasury",
    "BJ.01.m.09.b": "Money-box/-chest",
    "BJ.01.m.09.c": "Money-bag/-purse/-belt, etc",
    "BJ.01.n": "Monetary value",
    "BJ.01.n.01": "Price",
    "BJ.01.n.01.a": "Low price/rate",
    "BJ.01.n.01.b": "Discount",
    "BJ.01.n.01.c": "High price/rate",
    "BJ.01.n.01.d": "Fluctuation in price",
    "BJ.01.n.01.e": "Pricing",
    "BJ.01.o": "Charges",
    "BJ.01.o.01": "Freedom from charge",
    "BJ.01.p": "Payment",
    "BJ.01.p.01": "Non-payment",
    "BJ.01.p.02": "Contribution",
    "BJ.01.p.03": "Payment of debt",
    "BJ.01.q": "Hire/rent",
    "BJ.01.q.01": "Rent (land/real property)",
    "BJ.01.r": "Payment for privilege",
    "BJ.01.s": "Impost/due/tax",
    "BJ.01.s.01": "Tribute",
    "BJ.01.s.02": "Payment/service to feudal superior",
    "BJ.01.s.03": "Tax",
    "BJ.01.s.03.a": "Taxation",
    "BJ.01.s.03.b": "Tax collection",
    "BJ.01.s.03.c": "Payment of taxes",
    "BJ.01.s.03.d": "Types of tax",
    "BJ.01.s.04": "Fixed proportion dues/taxes",
    "BJ.01.s.05": "Local/municipal taxes/dues",
    "BJ.01.s.06": "Duty on goods",
    "BJ.01.s.07": "Toll for passing through",
    "BJ.01.t": "Compensation",
    "BJ.01.u": "Ransom",
    "BJ.01.v": "Illegal payment/exaction",
    "BJ.01.w": "Grants and allowances",
    "BJ.01.x": "Payment for labour/service",
    "BJ.01.x.01": "Fee for services rendered",
    "BJ.01.x.02": "Paying (money) for labour/service",
    "BJ.01.x.03": "Wage structures and scales",
    "BJ.01.y": "Management of money",
    "BJ.01.y.01": "Income/revenue/profit",
    "BJ.01.y.01.a": "Profit",
    "BJ.01.y.01.b": "Getting/making money",
    "BJ.01.y.02": "Expenditure",
    "BJ.01.y.02.a": "Moderation/reduction in expenditure",
    "BJ.01.y.02.b": "Waste of money/extravagance",
    "BJ.01.y.02.c": "Financial loss",
    "BJ.01.y.03": "Solvency",
    "BJ.01.y.04": "Insolvency",
    "BJ.01.y.04.a": "Indebtedness",
    "BJ.01.y.05": "Keeping accounts",
    "BJ.01.y.05.a": "Account/statement of",
    "BJ.01.y.06": "Management of national resources",
    "BJ.01.z": "Financial dealings",
    "BJ.01.z.01": "Types of money-dealing",
    "BJ.01.z.02": "Money-lending",
    "BJ.01.z.03": "Borrowing money",
    "BJ.01.z.04": "Banking",
    "BJ.01.z.05": "Insurance",
    "BJ.01.aa": "Stocks and shares",
    "BJ.01.aa.01": "Stocks/shares/bonds",
    "BK": "Leisure",
    "BK.01": "Entertainment",
    "BK.01.a": "Playfulness",
    "BK.01.b": "Frolicking/romping",
    "BK.01.c": "Place of amusement/entertainment generally",
    "BK.01.c.01": "Fairground/amusement park",
    "BK.01.d": "A specific form of amusement/ a pastime",
    "BK.01.d.01": "Collecting stamps",
    "BK.01.d.02": "Collecting other articles",
    "BK.01.d.03": "Spotting trains, watching birds, etc.",
    "BK.01.d.04": "Game",
    "BK.01.d.04.a": "Board-game",
    "BK.01.d.04.b": "Table game",
    "BK.01.d.04.c": "Billiards/pool/snooker",
    "BK.01.d.04.d": "Darts",
    "BK.01.d.04.e": "Card-game",
    "BK.01.d.04.f": "Card-sharping/cheating",
    "BK.01.d.04.g": "Games of chance",
    "BK.01.d.04.h": "Parlour and party games",
    "BK.01.d.04.i": "Quiz/panel game",
    "BK.01.d.04.j": "Children's game",
    "BK.01.d.05": "Betting",
    "BK.01.d.06": "Lottery/raffle",
    "BK.01.d.07": "Night-life",
    "BK.01.d.08": "Outing/excursion",
    "BK.01.d.09": "Holiday-making/tourism",
    "BK.01.e": "Toy/plaything",
    "BK.01.e.01": "Doll",
    "BK.01.e.02": "Soft toy",
    "BK.01.e.03": "Top",
    "BK.01.e.04": "Playground apparatus: swing, see-saw",
    "BK.01.e.05": "Ball/balloon",
    "BK.01.e.06": "Puzzle",
    "BK.01.e.07": "Toy weapons",
    "BK.01.e.08": "Rattles/whirrers",
    "BK.02": "Social event",
    "BK.02.a": "Large/public event",
    "BK.02.b": "Festive occasion",
    "BK.02.b.01": "Persons and characters",
    "BK.02.c": "A merry-making/convivial occasion",
    "BK.02.c.01": "Merry-making/conviviality",
    "BK.02.c.02": "Merry-maker",
    "BK.02.d": "Social gathering",
    "BK.02.d.01": "Party",
    "BK.02.e": "Fund-raising events",
    "BK.02.f": "Visit",
    "BK.02.f.01": "Visiting",
    "BK.02.f.02": "Visitor",
    "BK.02.g": "Hospitality",
    "BK.02.g.01": "Hospitable person",
    "BK.02.g.02": "Guest",
    "BK.02.g.03": "Invitation",
    "BK.03": "The Arts",
    "BK.03.a": "Artist",
    "BK.04": "Music",
    "BK.04.a": "Musical sound",
    "BK.04.a.01": "Sound of instruments",
    "BK.04.a.02": "Volume",
    "BK.04.a.03": "Pitch",
    "BK.04.a.04": "Duration of notes",
    "BK.04.a.05": "Melody/succession of sounds",
    "BK.04.a.06": "Harmony/sounds in combination",
    "BK.04.a.06.a": "Chord",
    "BK.04.b": "Piece of music",
    "BK.04.c": "Type of music",
    "BK.04.c.01": "Folk-music",
    "BK.04.c.02": "Jazz",
    "BK.04.c.03": "Pop music",
    "BK.04.c.04": "Dance-music",
    "BK.04.c.05": "Vocal music",
    "BK.04.c.05.a": "Religious/devotional",
    "BK.04.c.05.b": "Opera",
    "BK.04.c.05.c": "A song",
    "BK.04.d": "Composing music",
    "BK.04.d.01": "Composer",
    "BK.04.e": "Written/printed music",
    "BK.04.e.01": "Notation",
    "BK.04.f": "Performing music",
    "BK.04.f.01": "Singing",
    "BK.04.f.01.a": "Singing voice",
    "BK.04.f.02": "Playing instruments",
    "BK.04.f.02.a": "Playing wind instrument",
    "BK.04.f.02.b": "Playing stringed instrument",
    "BK.04.f.02.c": "Beating drum",
    "BK.04.f.02.d": "Bell-ringing",
    "BK.04.f.03": "Conducting",
    "BK.04.f.04": "A performance",
    "BK.04.f.04.a": "Place of performance/practice",
    "BK.04.g": "Musician",
    "BK.04.g.01": "Singer",
    "BK.04.g.01.a": "Company of singers",
    "BK.04.g.01.b": "Singer of church music",
    "BK.04.g.01.c": "Opera-singer",
    "BK.04.g.02": "Instrumentalist",
    "BK.04.g.02.a": "Company of instrumentalists",
    "BK.04.g.02.b": "Wind player",
    "BK.04.g.02.c": "String player",
    "BK.04.g.02.d": "Keyboard player",
    "BK.04.g.02.e": "Percussion player",
    "BK.04.g.03": "Conductor/leader",
    "BK.04.h": "Musical instrument",
    "BK.04.h.01": "Wind-instrument",
    "BK.04.h.01.a": "Pipe",
    "BK.04.h.01.b": "Horn",
    "BK.04.h.01.c": "Brass instruments",
    "BK.04.h.02": "Stringed instruments",
    "BK.04.h.02.a": "Harp/lyre",
    "BK.04.h.02.b": "Lute-/viol-type parts",
    "BK.04.h.02.c": "Guitar/lute type",
    "BK.04.h.02.d": "Bowable instrument",
    "BK.04.h.03": "Keyboard instrument",
    "BK.04.h.03.a": "Stringed keyboards",
    "BK.04.h.03.b": "Organ",
    "BK.04.h.04": "Drum",
    "BK.04.h.05": "Bell",
    "BK.04.i": "Study/science of music",
    "BK.04.i.01": "Music scholar",
    "BK.04.j": "Music appreciation",
    "BK.04.j.01": "Music lover",
    "BK.05": "Visual arts",
    "BK.05.a": "Work of art",
    "BK.05.b": "Representation in art",
    "BK.05.c": "Period/movement/school of art",
    "BK.05.c.01": "Ancient/primitive/pre-Renaissance",
    "BK.05.c.02": "Italian Renaissance/14-16th century",
    "BK.05.c.03": "17th century-mid 19th century",
    "BK.05.c.04": "Late 19th and 20th centuries",
    "BK.05.c.05": "Non-European periods/movements",
    "BK.05.d": "Painting and drawing",
    "BK.05.d.01": "Light and shade",
    "BK.05.d.02": "Relief and texture",
    "BK.05.d.03": "Perspective",
    "BK.05.d.04": "Painting",
    "BK.05.d.05": "Drawing",
    "BK.05.d.06": "Equipment for painting/drawing",
    "BK.05.d.07": "Display of pictures",
    "BK.05.d.08": "Condition/preservation of paintings",
    "BK.05.e": "Print-making",
    "BK.05.e.01": "Engraving",
    "BK.05.e.02": "Surface and planographic printing",
    "BK.05.e.03": "Photo-mechanical/process printing",
    "BK.05.f": "Plastic art",
    "BK.05.f.01": "Sculpture/carving",
    "BK.05.f.02": "Modelling",
    "BK.05.f.03": "Statuary",
    "BK.05.g": "Architecture",
    "BK.05.g.01": "Pillar",
    "BK.05.g.02": "Column",
    "BK.05.g.03": "Arch",
    "BK.05.g.04": "Architectural ornament",
    "BK.05.h": "Ornamental art and craft",
    "BK.05.h.01": "Mosaic",
    "BK.05.h.02": "Enamelling",
    "BK.05.h.03": "Ornamental glass-work",
    "BK.05.h.04": "Decoration of china",
    "BK.05.h.05": "Artistic work in metal",
    "BK.05.h.06": "Gilding and silvering",
    "BK.05.h.07": "Pattern/design",
    "BK.05.i": "Photography",
    "BK.05.i.01": "Photographer",
    "BK.05.i.02": "A photograph",
    "BK.05.i.03": "Action of taking photograph",
    "BK.05.i.04": "Camera",
    "BK.05.i.05": "Plates and films",
    "BK.05.i.06": "Photographic processes",
    "BK.05.i.07": "Viewing of photographs",
    "BK.06": "Literature",
    "BK.06.a": "A written composition",
    "BK.06.a.01": "Parts of a written composition",
    "BK.06.a.02": "Extract",
    "BK.06.a.03": "A compilation",
    "BK.06.b": "Writer/author",
    "BK.06.c": "Art/occupation of writer/author",
    "BK.06.d": "Literary world",
    "BK.06.e": "Style of language/writing",
    "BK.06.e.01": "Clarity",
    "BK.06.e.02": "Obscurity",
    "BK.06.e.03": "Conciseness",
    "BK.06.e.04": "Copiousness",
    "BK.06.e.05": "Vigour/force",
    "BK.06.e.06": "Weakness/feebleness",
    "BK.06.e.07": "Plainness",
    "BK.06.e.08": "Ornateness",
    "BK.06.e.09": "Elegance",
    "BK.06.e.10": "Inelegance",
    "BK.06.e.11": "Figure of speech",
    "BK.06.f": "Poetry",
    "BK.06.f.01": "Poem/piece of poetry",
    "BK.06.f.02": "Part of poem",
    "BK.06.f.03": "Versification",
    "BK.06.f.03.a": "Rhyme",
    "BK.06.f.03.b": "Metre",
    "BK.06.f.03.c": "Rhythm",
    "BK.06.f.04": "Recitation of poetry",
    "BK.06.f.05": "Study of poetry",
    "BK.06.f.06": "Poet",
    "BK.06.g": "Prose",
    "BK.06.g.01": "Non-fiction",
    "BK.06.g.01.a": "Treatise/dissertation",
    "BK.06.g.01.b": "Summary/epitome",
    "BK.06.g.02": "Essay",
    "BK.06.g.03": "Narrative/story",
    "BK.06.g.03.a": "Historical narrative",
    "BK.06.g.03.b": "Biography",
    "BK.06.g.03.c": "Legend/folk-tale",
    "BK.06.g.03.d": "Fiction",
    "BK.06.g.03.e": "Mythology",
    "BK.06.g.03.f": "Parable/allegory/apologue",
    "BK.06.g.03.g": "Romance",
    "BK.06.g.03.h": "Novel",
    "BK.06.g.03.i": "Science fiction, etc.",
    "BK.06.h": "Literary and textual criticism",
    "BK.06.h.01": "Literary criticism",
    "BK.06.h.02": "Textual criticism",
    "BK.07": "Performance arts",
    "BK.07.a": "Performer",
    "BK.07.b": "The theatre/the stage",
    "BK.07.b.01": "The staging of a theatrical production",
    "BK.07.b.02": "A theatre",
    "BK.07.b.02.a": "Stage",
    "BK.07.b.02.b": "Auditorium",
    "BK.07.b.02.c": "Theatrical equipment/accessories",
    "BK.07.b.03": "Theatre-going",
    "BK.07.b.03.a": "Theatre-goer",
    "BK.07.c": "Drama",
    "BK.07.c.01": "A play",
    "BK.07.c.02": "Playwriting",
    "BK.07.c.03": "Written/printed text",
    "BK.07.c.04": "Part/character",
    "BK.07.c.05": "Acting",
    "BK.07.c.06": "Actor",
    "BK.07.c.07": "Mime",
    "BK.07.c.08": "Pantomime",
    "BK.07.c.09": "Puppetry",
    "BK.07.d": "Variety, etc.",
    "BK.07.e": "Performance of jester/comedian",
    "BK.07.f": "Circus performance",
    "BK.07.g": "Acrobatic performance",
    "BK.07.h": "Legerdemain, etc.",
    "BK.07.i": "A public show/spectacle",
    "BK.07.j": "Optical shows",
    "BK.07.k": "Cinematography",
    "BK.07.k.01": "Film show",
    "BK.07.k.01.a": "A cinema",
    "BK.07.k.02": "A film",
    "BK.07.k.02.a": "Screenplay/script",
    "BK.07.k.02.b": "Actors/characters",
    "BK.07.k.03": "Filming",
    "BK.07.k.03.a": "Filming unit/team",
    "BK.07.k.03.b": "Special techniques",
    "BK.07.k.03.c": "Special effect",
    "BK.07.k.03.d": "Shot",
    "BK.07.k.03.e": "Filming equipment",
    "BK.07.k.04": "Editing",
    "BK.07.k.05": "Printing",
    "BK.07.k.06": "Projection",
    "BK.08": "Sport",
    "BK.08.a": "Match/competition",
    "BK.08.b": "Player/sportsman",
    "BK.08.c": "Types of play/actions/postures",
    "BK.08.d": "Winning/losing/scoring",
    "BK.08.e": "Recording score",
    "BK.08.f": "Judging/ umpiring",
    "BK.08.g": "Training",
    "BK.08.h": "Scouting/selecting",
    "BK.08.i": "Supporting",
    "BK.08.j": "Broadcasting",
    "BK.08.k": "Place for sports/games",
    "BK.08.l": "Athletics",
    "BK.08.m": "Gymnastics",
    "BK.08.m.01": "Exercise",
    "BK.08.n": "Fighting sports",
    "BK.08.n.01": "Wrestling",
    "BK.08.n.02": "Boxing",
    "BK.08.n.03": "Martial arts",
    "BK.08.n.04": "Jousting/tilting",
    "BK.08.n.05": "Fencing",
    "BK.08.n.06": "Gladiatorial combat",
    "BK.08.o": "Fighting/baiting animals",
    "BK.08.o.01": "Bull-fighting/bull-fight",
    "BK.08.o.02": "Fighting between animals",
    "BK.08.o.03": "Animal baiting",
    "BK.08.p": "Competitive shooting",
    "BK.08.p.01": "Archery",
    "BK.08.q": "Racing/race",
    "BK.08.q.01": "Racing on foot",
    "BK.08.q.02": "Swimming race",
    "BK.08.q.03": "Horse-racing",
    "BK.08.q.04": "Greyhound racing",
    "BK.08.q.05": "Racing with vehicles",
    "BK.08.q.05.a": "Motor-racing",
    "BK.08.q.05.b": "Bicycle-race",
    "BK.08.q.06": "Boat-racing/race",
    "BK.08.r": "Mountaineering/climbing",
    "BK.08.s": "Equestrian sports except racing",
    "BK.08.t": "Water-sports except racing",
    "BK.08.t.01": "Swimming",
    "BK.08.t.02": "Yachting and sailing",
    "BK.08.t.03": "Surfing",
    "BK.08.u": "Winter sports",
    "BK.08.u.01": "Skiing",
    "BK.08.u.02": "Skating",
    "BK.08.u.03": "Curling",
    "BK.08.u.04": "Ice hockey",
    "BK.08.v": "Ball game",
    "BK.08.v.01": "Characteristics of team ball games",
    "BK.08.v.02": "Hand-ball, etc.",
    "BK.08.v.03": "Basketball",
    "BK.08.v.04": "Football",
    "BK.08.v.04.a": "Association football",
    "BK.08.v.04.b": "Rugby football",
    "BK.08.v.04.c": "American football",
    "BK.08.v.05": "Hockey",
    "BK.08.v.05.a": "Hurling, shinty, and other games similar to hockey",
    "BK.08.v.06": "Baseball",
    "BK.08.v.06.a": "Baseball player",
    "BK.08.v.06.b": "Baseball ground",
    "BK.08.v.07": "Cricket",
    "BK.08.v.07.a": "Batting",
    "BK.08.v.07.b": "Dismissal of batsman",
    "BK.08.v.07.c": "Bowling",
    "BK.08.v.07.d": "Fielding",
    "BK.08.v.07.e": "Cricketer",
    "BK.08.v.07.f": "Umpiring and scoring",
    "BK.08.v.07.g": "Cricket equipment",
    "BK.08.v.07.h": "Cricket-ground",
    "BK.08.v.08": "Racket games",
    "BK.08.v.08.a": "Rackets",
    "BK.08.v.08.b": "Real tennis",
    "BK.08.v.08.c": "Lawn-tennis",
    "BK.08.v.09": "Golf",
    "BK.08.v.10": "Croquet",
    "BK.08.v.11": "Bowls/bowling",
    "BK.08.v.12": "Ninepins/ten-pins",
    "BK.09": "Dancing",
    "BK.09.a": "Dancer generally",
    "BK.09.b": "Dancing-school/class",
    "BK.09.c": "Ball/dance",
    "BK.09.d": "Place for dancing",
    "BK.09.e": "Style/manner of dancing",
    "BK.09.f": "Folk-dance/-dancing",
    "BK.09.g": "Country-dance/-dancing",
    "BK.09.h": "Ball-room dancing",
    "BK.09.i": "Lively dances",
    "BK.09.j": "Shaking/jiving dances",
    "BK.09.k": "War-dance",
    "BK.09.l": "Morris-dance",
    "BK.09.m": "Movements/steps",
    "BK.09.n": "Ballet",
    "BK.09.o": "Modern dance",
    "X": "Object",
    "D": "Disease"
};

export default hansard;